{
  "addons.addonList": "Add-on liste",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Opret og hent din API nøgle via dette link",
  "addons.ambientWeatherDescription": "Ambient vejr stationer (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API-nøgle",
  "addons.applicationKey": "Applikationsnøgle",
  "addons.connect": "Forbind",
  "addons.davisApiSecret": "API hemmelig",
  "addons.davisApiV2Key": "V2 API-nøgle",
  "addons.davisDescription": "Davis vejr stationer (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Hent din V2 API nøgle fra dette link",
  "addons.disconnect": "Afbryd",
  "addons.ecowittCreateAndRetrieveKeys": "OPret og hent både en AOI nøgle og en applikations nøgle fra dette link",
  "addons.ecowittDescription": "Ecowitt leverer professionelle wifi vejrstationer, inde- og udetermometre, fugtighedsmålere, præcisions regnmålere, luftkvalitetsmålere og mere",
  "addons.helpLink": "Sådan forbinder du {provider}",
  "addons.myAcuriteAccountOnHold": "Din konto er blevet tilbageholdt. Indtast venligst din adgangskode for at oprette forbindelse til din konto igen",
  "addons.myAcuriteDescription": "AcuRite er det #1 vejrstationsmærke i Nordamerika. Som førende inden for tid, temperatur og vejrteknologi giver AcuRite dig detaljerede oplysninger om dit indendørs og udendørs miljø, så du kan planlægge din dag med tillid.",
  "addons.myAcuriteEnterCredentials": "Indtast dine My AcuRite-legitimationsoplysninger for at forbinde din My AcuRite-konto med SmartMixin",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Brug din Netatmo-termostat til at ændre dit hjems temperatur, fra din seng eller fra den anden side af jorden",
  "addons.netatmoThermostat": "Netatmo Thermostat",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Din personlige vejrstation derhjemme",
  "addons.or": "eller",
  "addons.providerAccountDisconnected": "Forbindelsen til din vejrtjeneste er udløbet. Tilslut igen for at genoptage dataopdateringer.",
  "addons.reconnect": "Forbind igen",
  "addons.weatherflowCreateToken": "Opret og hent dit token fra dette link",
  "addons.weatherflowTempestDescription": "Tempest Weather System med indbygget vind- og regnmåler",
  "addons.wundergroundApiKey": "API-nøgle",
  "addons.wundergroundDescription": "Weather Underground er et globalt fællesskab af folk, der udveksler data mellem forskellige vejrstationer mm.,",
  "addons.wundergroundRetrieveApiKey": "Hent din API nøgle fra dette link",
  "addons.wundergroundRetrieveStationId": "Hent din stations ID fra dette link",
  "addons.wundergroundStationId": "Station ID",
  "airQuality.adviceActivityGood": "En ideel dag til at være aktiv udendørs",
  "airQuality.adviceActivityHazardous": "Undgå al fysisk aktivitet udendørs",
  "airQuality.adviceActivityLabel": "Fysisk aktivitet",
  "airQuality.adviceActivityModerate": "En god dag til at være aktiv udendørs",
  "airQuality.adviceActivitySensitive": "Overvej kortere og mindre intense aktiviteter udendørs",
  "airQuality.adviceActivityUnhealthy": "Begræns lange eller intense aktiviteter, og hold flere pauser",
  "airQuality.adviceActivityVeryUnhealthy": "Undgå lange eller intense aktiviteter; overvej at flytte dem indendørs",
  "airQuality.adviceGroupsGood": "Ingen særlige forholdsregler nødvendige",
  "airQuality.adviceGroupsHazardous": "Bliv indendørs, og hold aktivitetsniveauet lavt",
  "airQuality.adviceGroupsLabel": "Følsomme grupper",
  "airQuality.adviceGroupsModerate": "Særligt følsomme personer: kortere og mindre intense aktiviteter",
  "airQuality.adviceGroupsSensitive": "Gør aktiviteter udendørs kortere og mindre intense, og hold flere pauser",
  "airQuality.adviceGroupsUnhealthy": "Undgå lange eller intense aktiviteter udendørs; overvej at flytte dem indendørs",
  "airQuality.adviceGroupsVeryUnhealthy": "Undgå al fysisk aktivitet udendørs; udskyd den eller flyt den indendørs",
  "airQuality.adviceTimingLabel": "Hvornår du bør gå ud",
  "airQuality.adviceTimingMorning": "Helst om formiddagen – der er ozonniveauet lavere",
  "airQuality.airQuality": "Luftkvalitet",
  "airQuality.airQualityIndex": "Luftkvalitetsindex",
  "airQuality.aqiForecast": "Prognose for luftkvalitet",
  "airQuality.co": "Kulilte",
  "airQuality.dailyForecast": "Daglig vejrudsigt",
  "airQuality.details": "Detaljer",
  "airQuality.dominantPollutant": "Dominerende forurenende stof",
  "airQuality.expectedPeak": "Forventet top",
  "airQuality.good": "God",
  "airQuality.goodDescription": "Luftkvaliteten anses for tilfredsstillende og risikoen for luftforurening er lille eller ikke eksisterende",
  "airQuality.hazardous": "Farlig",
  "airQuality.hazardousDescription": "Helbredsadvarsel: Nogle kan opleve helbredsskader",
  "airQuality.indoorAirQuality": "Indendørs luftkvalitet",
  "airQuality.mgm3": "mg/m³",
  "airQuality.moderate": "Moderat",
  "airQuality.moderateDescription": "Luftkvaliteten er acceptabel. Men for visse typer av forureninger kan der findes et mindre helbredsproblem for et meget lille antal mennesker, som er overfølsomme over for luftforureninger",
  "airQuality.no2": "Kvælstofdioxyd",
  "airQuality.noForecastForLocation": "Der er ingen luftkvalitetsprognose for denne placering.",
  "airQuality.now": "Nu",
  "airQuality.o3": "Ozon",
  "airQuality.pm10": "Partikler med en diameter på 10 μm eller mindre",
  "airQuality.pm25": "Partikler med en diameter på 2,5 μm eller mindre",
  "airQuality.pollutants": "Forurenende stoffer",
  "airQuality.ppb": "ppb",
  "airQuality.recommendations": "Anbefalinger",
  "airQuality.sensitiveUnhealthy": "Usundt for følsomme personer",
  "airQuality.sensitiveUnhealthyDescription": "Følsomme personer kan opleve helbredsproblemer. Normale mennesker vil intet mærke",
  "airQuality.so2": "Svovldioxyd",
  "airQuality.subIndex": "AQI-delindeks",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Forstå indekset",
  "airQuality.unhealthy": "Usundt",
  "airQuality.unhealthyDescription": "Alle kan opleve helbredseffekter, især følsomme personer",
  "airQuality.veryUnhealthy": "Meget usundt",
  "airQuality.veryUnhealthyDezscription": "Advarsler om nødsituationer. Det er sandsynligt at hele befolkningen påvirkes",
  "alerts.addAlert": "Tilføj advarsel",
  "alerts.addCondition": "Tilføj betingelse",
  "alerts.alertAdded": "Advarsel tilføjet",
  "alerts.alertAuthorizationNotice": "Advarsler virker kun hvis SmartMixin har tilladelse til at vise notifikationer",
  "alerts.alertDeleted": "Advarsel slettet",
  "alerts.alertEdited": "Advarsel rettet",
  "alerts.alertName": "Advarsels navn",
  "alerts.alertWhen": "Jeg vil advares når",
  "alerts.aqiGreaterThan": "AQI over",
  "alerts.aqiGreaterThanThreshold": "AQI over {value}{unit}",
  "alerts.aqiLessThan": "AQI under",
  "alerts.aqiLessThanThreshold": "AQI under {value}{unit}",
  "alerts.atLeastOneCondition": "Der skal tilføjes mindst én betingelse",
  "alerts.co2GreaterThan": "CO2 over",
  "alerts.co2GreaterThanThreshold": "CO2 over {value}{unit}",
  "alerts.co2LessThan": "CO2 under",
  "alerts.co2LessThanThreshold": "CO2 under {value}{unit}",
  "alerts.conditions": "Betingelser",
  "alerts.createAlert": "Opret advarsel",
  "alerts.dailyPrecipitationGreaterThan": "Daglig nedbør større end",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Daglig nedbør over grænsen på {value}{unit}",
  "alerts.deleteAlert": "Slet advarsel",
  "alerts.editAlert": "Rediger advarsel",
  "alerts.editCondition": "Rediger betingelse",
  "alerts.gustSpeedGreaterThan": "Vindstød over",
  "alerts.gustSpeedGreaterThanThreshold": "Vindstød over {value}{unit}",
  "alerts.gustSpeedLessThan": "Vindstød under",
  "alerts.gustSpeedLessThanThreshold": "Vindstød under {value}{unit}",
  "alerts.heatIndexGreaterThan": "Varmeindeks over",
  "alerts.heatIndexGreaterThanThreshold": "Varmeindeks over {value}{unit}",
  "alerts.heatIndexLessThan": "Varmeindeks under",
  "alerts.heatIndexLessThanThreshold": "Varmeindeks under {value}{unit}",
  "alerts.humidexGreaterThan": "Luftfugtighedsindeks over",
  "alerts.humidexGreaterThanThreshold": "Luftfugtighedsindeks over {value}{unit}",
  "alerts.humidexLessThan": "Luftfugtighedsindeks under",
  "alerts.humidexLessThanThreshold": "Luftfugtighedsindeks under {value}{unit}",
  "alerts.humidityGreaterThan": "Fugtighed over",
  "alerts.humidityGreaterThanThreshold": "Fugtighed over {value}{unit}",
  "alerts.humidityLessThan": "Fugtighed under",
  "alerts.humidityLessThanThreshold": "Fugtighed under {value}{unit}",
  "alerts.inProgress": "Advarsel, betingelse(r) opfyldt",
  "alerts.myAlerts": "Mine advarsler",
  "alerts.noConfiguredAlert": "Du har ikke oprettet nogen advarsler endnu, start med at tilføje en",
  "alerts.noiseGreaterThan": "Støj over",
  "alerts.noiseGreaterThanThreshold": "Støj over {value}{unit}",
  "alerts.noiseLessThan": "Støj under",
  "alerts.noiseLessThanThreshold": "Støj under {value}{unit}",
  "alerts.noteOnConditions": "Bemærk at advarslen udløses når alle de nedenstående betingelser er opfyldt",
  "alerts.noTriggerHistory": "Denne alarm er endnu ikke blevet udløst.",
  "alerts.pm10GreaterThan": "PM 10 over",
  "alerts.pm10GreaterThanThreshold": "PM 10 over {value}{unit}",
  "alerts.pm10LessThan": "PM 10 under",
  "alerts.pm10LessThanThreshold": "PM 10 under {value}{unit}",
  "alerts.pm1GreaterThan": "PM1 over",
  "alerts.pm1GreaterThanThreshold": "PM1 over {value}{unit}",
  "alerts.pm1LessThan": "PM 1 under",
  "alerts.pm1LessThanThreshold": "PM 1 under {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2.5 over",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 over {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2.5 under",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 under {value}{unit}",
  "alerts.postStormSummary": "Opsummering efter regn",
  "alerts.postStormSynopsisHelper": "Du får en opsummerende notifikation, hver gang regnvejret slutter.",
  "alerts.postStormSynopsisSoleCondition": "En opsummering efter storm kan ikke kombineres med andre betingelser.",
  "alerts.precipitationGreaterThan": "Timevis nedbør større end",
  "alerts.precipitationGreaterThanThreshold": "Timevis nedbør over grænsen på {value}{unit}",
  "alerts.pressureGreaterThan": "Tryk over",
  "alerts.pressureGreaterThanThreshold": "Tryk over {value}{unit}",
  "alerts.pressureLessThan": "Tryk under",
  "alerts.pressureLessThanThreshold": "Tryk under {value}{unit}",
  "alerts.rainRateGreaterThan": "Regnintensitet større end",
  "alerts.rainRateGreaterThanThreshold": "Regnintensitet over grænsen på {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Solstråling over",
  "alerts.solarRadiationGreaterThanThreshold": "Solstråling over {value}{unit}",
  "alerts.solarRadiationLessThan": "Solstråling under",
  "alerts.solarRadiationLessThanThreshold": "Solstråling under {value}{unit}",
  "alerts.stormChartUnavailable": "Regnhistorikken for dette regnvejr er ikke tilgængelig.",
  "alerts.stormDetail": "Opsummering af regnvejr",
  "alerts.stormDuration": "Varighed",
  "alerts.stormEnd": "Slut",
  "alerts.stormPeakRate": "Maksimal regnintensitet",
  "alerts.stormStart": "Start",
  "alerts.stormTotal": "Samlet nedbør",
  "alerts.temperatureGreaterThan": "Temperatur over",
  "alerts.temperatureGreaterThanThreshold": "Temperatur over {value}{unit}",
  "alerts.temperatureLessThan": "Temperatur under",
  "alerts.temperatureLessThanThreshold": "Temperatur under {value}{unit}",
  "alerts.thswGreaterThan": "THSW over",
  "alerts.thswGreaterThanThreshold": "THSW over {value}{unit}",
  "alerts.thswLessThan": "THSW under",
  "alerts.thswLessThanThreshold": "THSW under {value}{unit}",
  "alerts.thwGreaterThan": "THW over",
  "alerts.thwGreaterThanThreshold": "THW over {value}{unit}",
  "alerts.thwLessThan": "THW under",
  "alerts.thwLessThanThreshold": "THW under {value}{unit}",
  "alerts.triggerHistory": "Alarmhistorik",
  "alerts.uvGreaterThan": "UV index over",
  "alerts.uvGreaterThanThreshold": "UV index over {value}{unit}",
  "alerts.uvLessThan": "UV undex under",
  "alerts.uvLessThanThreshold": "UV index under {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Sigtbarhed over {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Sigtbarhed under {value}{unit}",
  "alerts.visiblityGreaterThan": "Sigtbarhed over",
  "alerts.visiblityLessThan": "Sigtbarhed under",
  "alerts.whichMeasure": "Hvilken værdi vil du gerne advares om?",
  "alerts.whichModule": "Hvilket modul vil du blive advaret om?",
  "alerts.windChillGreaterThan": "Vind Chill over",
  "alerts.windChillGreaterThanThreshold": "Vind Chill over {value}{unit}",
  "alerts.windChillLessThan": "Vind Chill under",
  "alerts.windChillLessThanThreshold": "Vind Chill under {value}{unit}",
  "alerts.windSpeedGreaterThan": "Vindhastighed over",
  "alerts.windSpeedGreaterThanThreshold": "Vindhastighed over {value}{unit}",
  "alerts.windSpeedLessThan": "Vindhastighed under",
  "alerts.windSpeedLessThanThreshold": "Vindhastighed under {value}{unit}",
  "astral.aboveHorizonAllDay": "Over horisonten hele dagen",
  "astral.aboveTheHorizon": "over horisonten",
  "astral.apparentSize": "Vinkelstørrelse",
  "astral.apparentSizeAcross": "{size} i diameter",
  "astral.astronomicalDawn": "Astronomisk morgengry",
  "astral.astronomicalDusk": "Astronomisk tusmørke",
  "astral.astronomicalSunPhase": "Astronomisk {sunPhase}",
  "astral.belowHorizonAllDay": "Under horisonten hele dagen",
  "astral.belowHorizonSince": "Under horisonten siden kl. {time}",
  "astral.belowHorizonSinceOn": "Under horisonten siden {day} kl. {time}",
  "astral.brightAllNight": "Lyst hele natten — aldrig helt mørkt",
  "astral.brightestMoment": "Lyseste øjeblik",
  "astral.civilDawn": "Borgerligt morgengry",
  "astral.civilDusk": "Borgerligt tusmørke",
  "astral.civilSunPhase": "Civil {sunPhase}",
  "astral.darkSkyBetween": "Mørk himmel {from} → {to}",
  "astral.darkSkyWindow": "Mørk himmel {from} → {to} · {duration} uden måne",
  "astral.dawn": "Daggry",
  "astral.dayLength": "Daglængde",
  "astral.daylightThroughTheYear": "Daglængde gennem året",
  "astral.dayOfCycle": "dag {day} af {total}",
  "astral.doesNotOccurToday": "Sker ikke i dag",
  "astral.domeHint": "Træk for at gå gennem natten",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.dusk": "Skumring",
  "astral.earliestSunrise": "Tidligste solopgang",
  "astral.earliestSunset": "Tidligste solnedgang",
  "astral.equinox": "Jævndøgn",
  "astral.equinoxIn": "Jævndøgn om {days, plural, one {# dag} other {# dage}}",
  "astral.evening": "Aften",
  "astral.exactPhaseAt": "Præcis kl. {time}",
  "astral.firstQuarter": "Første kvarter",
  "astral.firstSunriseIn": "Første solopgang om {days, plural, one {# dag} other {# dage}}",
  "astral.firstSunsetIn": "Første solnedgang om {days, plural, one {# dag} other {# dage}}",
  "astral.fullMoon": "Fuldmåne",
  "astral.goldenHourBegins": "Den gyldne time begynder",
  "astral.goldenHourEnds": "Den gyldne time slutter",
  "astral.highestPoint": "Højeste punkt",
  "astral.inDays": "om {days, plural, one {# dag} other {# dage}}",
  "astral.lastQuarter": "Sidste kvarter",
  "astral.latestSunrise": "Seneste solopgang",
  "astral.latestSunset": "Seneste solnedgang",
  "astral.litShort": "Belyst",
  "astral.longestDay": "Længste dag",
  "astral.lowestPoint": "Laveste punkt",
  "astral.maxAltitudeShort": "Maks.",
  "astral.midday": "Middag",
  "astral.midnightSun": "Midnatssol",
  "astral.midnightSunPeriod": "Midnatssol",
  "astral.milestoneFootnotePolar": "Her står solen hverken op eller går ned {days, plural, one {# dag} other {# dage}} om året, så i stedet for de sædvanlige yderpunkter for solopgang og solnedgang viser listen, hvornår det sker.",
  "astral.milestoneFootnoteTemperate": "Den tidligste solnedgang og den seneste solopgang falder ikke på den korteste dag — det er tidsligningen, ikke solhvervet, der bestemmer de to datoer.",
  "astral.moon": "Måne",
  "astral.moonAltitude": "Højde",
  "astral.moonDirection": "Azimut",
  "astral.moonDistance": "Afstand",
  "astral.moonlessFor": "{duration} uden måne",
  "astral.moonPhases": "Månefaser",
  "astral.moonrise": "Måneopgang",
  "astral.moonset": "Månenedgang",
  "astral.moonUpAllNight": "Månen er oppe hele natten",
  "astral.moonWashesOutNight": "Månen er oppe fra {rise} til {set} og lyser hele natten op",
  "astral.morning": "Morgen",
  "astral.nauticalDawn": "Nautisk morgengry",
  "astral.nauticalDusk": "Nautisk tusmørke",
  "astral.nauticalSunPhase": "Nautisk {sunPhase}",
  "astral.newMoon": "Nymåne",
  "astral.nextDay": "+1 dag",
  "astral.nextProperlyDarkNight": "Næste rigtigt mørke nat",
  "astral.nextRise": "næste opgang kl. {time}",
  "astral.nextRiseOn": "næste opgang {day} kl. {time}",
  "astral.nextSevenNights": "De næste syv nætter",
  "astral.noAstronomicalDarknessTonight": "Intet astronomisk mørke i nat",
  "astral.noDarkNightAhead": "Ingen de næste to uger",
  "astral.noon": "Middag",
  "astral.noSunriseToday": "Ingen solopgang i dag",
  "astral.nowAtBearing": "nu {altitude} · azimut {direction}",
  "astral.observing": "Observation",
  "astral.ofDaylightLeft": "dagslys tilbage",
  "astral.overTheNextThreeWeeks": "over de næste 3 uger",
  "astral.percentLit": "{percent} oplyst",
  "astral.polarNight": "Polarnat",
  "astral.polarNightPeriod": "Polarnat",
  "astral.remainingDaylight": "Resterende dagslys",
  "astral.rightNow": "Lige nu",
  "astral.riseShort": "Op",
  "astral.setShort": "Ned",
  "astral.shortestDay": "Korteste dag",
  "astral.solarNoon": "Sand middag",
  "astral.solstice": "Solhverv",
  "astral.sunBelowHorizon": "Solen {degrees}° under horisonten",
  "astral.sunEvents": "Solbegivenheder",
  "astral.sunNeverDarkEnough": "Solen kommer aldrig 18° under horisonten",
  "astral.sunNeverSets": "Solen går ikke ned",
  "astral.sunrise": "Solopgang",
  "astral.sunriseAndSunset": "Solopgang og solnedgang",
  "astral.sunriseAt": "Solopgang kl. {time}",
  "astral.sunset": "Solnedgang",
  "astral.sunsetAt": "Solnedgang kl. {time}",
  "astral.thisYearAtNorth": "I år på {degrees}° N",
  "astral.thisYearAtSouth": "I år på {degrees}° S",
  "astral.tonight": "I nat",
  "astral.totalDaylight": "Dagslys ialt",
  "astral.twilightAllNight": "Tusmørke hele natten — aldrig helt mørkt",
  "astral.upFor": "{duration} over horisonten",
  "astral.usableLight": "Brugbart lys",
  "astral.vsAverage": "{percent} ift. gns.",
  "astral.vsYesterday": "ift. i går",
  "astral.waningCrescent": "Aftagende månesegl",
  "astral.waningGibbous": "Aftagende trekvartmåne",
  "astral.waxingCrescent": "Tiltagende månesegl",
  "astral.waxingGibbous": "Tiltagende trekvartmåne",
  "astral.whereToLook": "Hvor skal man kigge",
  "astral.withoutTheMoon": "{duration} uden måne",
  "auth.alreadyHaveAccount": "Har du allerede en konto?",
  "auth.authContainerTagline": "Dit personlige vejr-dashboard. Tilslut dine stationer og få realtidsdata lige ved hånden.",
  "auth.backToLogin": "Tilbage til login",
  "auth.catchPhrase": "Weather Intelligence platform",
  "auth.checkYourEmail": "Tjek din e-mail",
  "auth.continueWithApple": "Fortsæt med Apple",
  "auth.continueWithFacebook": "Fortsæt med Facebook",
  "auth.continueWithGoogle": "Fortsæt med Google",
  "auth.email": "Emailadresse",
  "auth.emailRequiredLoginFacebook": "Emailtilladelse er påkrævet",
  "auth.emailVerification": "E-mailbekræftelse",
  "auth.emailVerificationFailure": "Der er opstået et problem med din emailbekræftelse.",
  "auth.emailVerificationSuccess": "Din email er bekræftet.",
  "auth.firstName": "Fornavn",
  "auth.forgotPassword": "Glemt adgangskode?",
  "auth.forgotPasswordSubtitle": "Indtast din e-mail, og vi sender dig et link til at nulstille din adgangskode.",
  "auth.lastName": "Efternavn",
  "auth.login": "Login",
  "auth.loginSubtitle": "Velkommen tilbage! Indtast venligst dine oplysninger.",
  "auth.loginToSmartMixinDescription": "Indtast dine SmartMixin-legitimationsoplysninger for at få adgang til din konto.",
  "auth.logout": "Log af",
  "auth.logoutConfirmation": "Er du sikker på at du vil logge af?",
  "auth.noAccountYet": "Har du ikke en konto endnu?",
  "auth.or": "eller",
  "auth.password": "Adgangskode",
  "auth.passwordAgain": "Adgangskode gentag",
  "auth.passwordReset": "Nulstil adgangskode",
  "auth.passwordResetSuccess": "Din adgangskode er blevet opdateret.",
  "auth.register": "Opret konto",
  "auth.registerDescription": "Opret en gratis SmartMixin-konto for at forbinde dine vejrstationer, følge vejrdata og få adgang til avancerede analyseværktøjer.",
  "auth.registerSubtitle": "Opret din konto for at komme i gang.",
  "auth.registerSuccess": "Du har registreret dig! Vi har lige sendt dig et bekræftelseslink på {emailAddress} med yderligere instruktioner.",
  "auth.restorePassword": "Gendan adgangskode",
  "auth.restorePasswordSuccess": "Vi har lige sendt dig et link til nulstilling af adgangskode på {emailAddress} med yderligere instruktioner.",
  "auth.sendReset": "Send nulstillingsinstruktioner",
  "auth.signInWithApple": "",
  "auth.socialAccount": "eller brug din konto",
  "auth.welcome": "Velkommen til SmartMixin",
  "auth.welcomeBack": "Velkommen tilbage!",
  "calendar.april": "April",
  "calendar.august": "August",
  "calendar.dateFormat": "Datoformat",
  "calendar.day": "Dag",
  "calendar.december": "December",
  "calendar.end": "Ende",
  "calendar.february": "Februar",
  "calendar.hours": "timer",
  "calendar.hoursShort": "t",
  "calendar.january": "Januar",
  "calendar.july": "Juli",
  "calendar.june": "Juni",
  "calendar.last24Hours": "sidste 24 timer",
  "calendar.last30Days": "sidste 30 dage",
  "calendar.last7Days": "sidste 7 dage",
  "calendar.march": "Marts",
  "calendar.max": "Maks.",
  "calendar.may": "Maj",
  "calendar.month": "Måned",
  "calendar.months": "måneder",
  "calendar.november": "November",
  "calendar.october": "Oktober",
  "calendar.oneDay": "1-dags",
  "calendar.oneHour": "1-times",
  "calendar.oneMonth": "1-måneds",
  "calendar.oneWeek": "1-uges",
  "calendar.previous24Hours": "De foregående 24 timer",
  "calendar.previous30Days": "De foregående 30 dage",
  "calendar.previous7Days": "De foregående 7 dage",
  "calendar.previousDay": "Forrige dag",
  "calendar.previousMonth": "Forrige måned",
  "calendar.previousWeek": "Forrige uge",
  "calendar.previousYear": "Forrige år",
  "calendar.sameDayLastYear": "Samme dag sidste år",
  "calendar.sameMonthLastYear": "Samme måned sidste år",
  "calendar.selectADate": "Vælg en dato",
  "calendar.selectAggregation": "Vælg vist værdi",
  "calendar.selectAMonth": "Vælg en måned",
  "calendar.selectAYear": "Vælg et år",
  "calendar.selectGranularity": "Vælg en granularitet",
  "calendar.selectTimescale": "Vælg en tidsskala",
  "calendar.september": "September",
  "calendar.sixHours": "6-timers",
  "calendar.start": "Begyndelse",
  "calendar.thirtyMinutes": "30-minutters",
  "calendar.threeHours": "3-timers",
  "calendar.use24HourFormat": "Brug 24-timers format",
  "calendar.week": "Uge",
  "calendar.year": "År",
  "calendar.yesterday": "I går",
  "common.accountDeleted": "Din konto er blevet slettet",
  "common.accountOnHold": "Din kontoforbindelse er udløbet. Tilslut igen for at genoptage dataopdateringer.",
  "common.add": "Tilføj",
  "common.addAStation": "Tilføj en station",
  "common.addToFavorites": "Tilføj til favoritter",
  "common.addYourOwnStation": "Tilføj din egen station",
  "common.afternoon": "Eftermiddag",
  "common.alreadyPremium": "Du har allerede en premiumkonto!",
  "common.alsoAvailableOn": "Også tilgængelig på:",
  "common.altitude": "Højde",
  "common.analysis": "Analyse",
  "common.aroundMe": "Omkring mig",
  "common.articleCount": "{count, plural, one {# artikel} other {# artikler}}",
  "common.articleNotFound": "Artikel ikke fundet",
  "common.articleNotFoundDescription": "Den artikel, du leder efter, findes ikke.",
  "common.average": "Middel",
  "common.averageOverThePeriod": "Gennemsnitligt i perioden",
  "common.away": "Væk",
  "common.back": "Tilbage",
  "common.backToHelpCenter": "Tilbage til hjælpecenter",
  "common.backToHome": "Tilbage til Forsiden",
  "common.bad": "Dårlig",
  "common.batteryLevel": "Batteriniveau",
  "common.bestValue": "Bedste Værdi",
  "common.billingDetailsAndroid": "I den gratis prøveversion vil du ikke blive opkrævet, hvis du annullerer 24 timer før den gratis introduktionsperiode udløber. Når prøveperioden er overstået, kan du når som helst opsige SmartMixin-abonnementet via dine Google Play-kontoindstillinger - ellers fornys abonnementet automatisk. Opsigelse skal ske 24 timer inden abonnementsperioden udløber for at undgå endnu en opkrævning, som vist i knappen ovenfor. Abonnementsbetalinger opkræves på din Google Play-konto ved bekræftelse af dit køb samt ved påbegyndelse af en ny betalingsperiode.",
  "common.billingDetailsIos": "I den gratis prøveversion vil du ikke blive opkrævet, hvis du annullerer 24 timer før den gratis introduktionsperiode udløber. Når prøveperioden er overstået, kan du når som helst opsige SmartMixin-abonnementet via kontoindstillingerne i Appstore - ellers fornys abonnmentet automatisk. Opsigelse skal ske 24 timer inden abonnementsperioden udløber for at undgå endnu en opkrævning, som vist i knappen ovenfor. Abonnementsbetalinger opkræves på din Appstore-konto ved bekræftelse af dit køb samt ved påbegyndelse af en ny betalingsperiode.",
  "common.boilerOn": "Kedel tændt",
  "common.browseByCategory": "Gennemse efter kategori",
  "common.calendarView": "Kalendervisning",
  "common.cancel": "Annullér",
  "common.cannotBeEmpty": "Dette felt kan ikke være tomt",
  "common.cardDetails": "Kortoplysninger",
  "common.categoryNotFound": "Kategori ikke fundet",
  "common.categoryNotFoundDescription": "Denne kategori findes ikke eller har ingen artikler.",
  "common.charts": "Grafer",
  "common.chartView": "Grafvisning",
  "common.clearRecentLocations": "Ryd alle",
  "common.close": "Luk",
  "common.comparison": "Sammenligning",
  "common.contactMe": "Kontakt mig",
  "common.currentDay": "I dag",
  "common.currentLocation": "Nuværende placering",
  "common.currentObservations": "Aktuelle observationer",
  "common.currentRainEvent": "Aktuel regnbegivenhed",
  "common.currentRate": "Regnintensitet",
  "common.currentWeatherConditions": "Aktuelle betingelser",
  "common.customizeComparisonMetrics": "Tilpas sammenligningsmetrikker",
  "common.customizeComparisonMetricsDescription": "Træk elementer for at ændre rækkefølgen på dine sammenligningsmetrikker. Tryk på øjeikonet for at vise eller skjule metrikker.",
  "common.customizeDashboard": "Tilpas",
  "common.customizeDashboardDescription": "Træk elementer for at ændre rækkefølgen på dit dashboard. Tryk på øjeikonet for at vise eller skjule sektioner.",
  "common.customizedStationName": "Tilpasset stationsnavn",
  "common.dailyForecast": "Daglig vejrudsigt",
  "common.dashboard": "Dashboard",
  "common.default": "Standard",
  "common.defaultForecastModelChip": "Standard · {name}",
  "common.delete": "Slet",
  "common.deleteAccount": "Slet din konto",
  "common.deleteAccountConfirmation": "Er du sikker på at du vil slette din konto?",
  "common.deleteAccountDescription": "Denne handling sletter din konto og alle dine oplysninger. Der er ingen vej tilbage.",
  "common.details": "Detaljer",
  "common.durationHours": "{hours} t",
  "common.durationHoursMinutes": "{hours} t {minutes} min",
  "common.durationMinutes": "{minutes} min",
  "common.durationMinutesSeconds": "{minutes} min {seconds} s",
  "common.durationSeconds": "{seconds} s",
  "common.edit": "Rediger",
  "common.editor": "Editor",
  "common.endTime": "Ende",
  "common.evening": "Aften",
  "common.exitFullscreen": "Forlad fuld skærm",
  "common.exploreWeatherMap": "Udforsk Vejrkortet",
  "common.favoriteLocations": "Favoritter",
  "common.favoriteLocationsEmpty": "Du kan tilføje op til 5 yndlingssteder.",
  "common.favoriteStations": "Favoritstationer",
  "common.feedbackHelpsImprove": "Din feedback hjælper os med at forbedre vores hjælpeartikler.",
  "common.feedbackReasonNotAnswer": "Den besvarer ikke mit spørgsmål",
  "common.feedbackReasonOutdated": "Oplysningerne er forældede",
  "common.feedbackReasonUnclear": "Instruktionerne er uklare",
  "common.feedbackWhatWentWrong": "Hvad var problemet?",
  "common.filterStationDescription": "Vis ikke stationer med upålidelige målinger",
  "common.filterStations": "Filtrer stationer",
  "common.filterStationSourceDescription": "Vælg stationsudbydere, som du vil have vist på kortet",
  "common.findStationsNearYou": "Find stationer i nærheden",
  "common.firmwareVersion": "Firmwareversion",
  "common.forecast": "Vejrudsigt",
  "common.forecastAllModels": "Alle modeller ({count})",
  "common.forecastComparisonDescription": "Sammenlign nemt data fra flere kilder",
  "common.forecastFollowingPreferences": "Følger dine præferencer",
  "common.forecastModelComparison": "Sammenligning af vejrudsigtsmodeller",
  "common.forecastModelCoverage": "Dækning",
  "common.forecastModelDescription": "Beskrivelse",
  "common.forecastModelDescription_AROME": "Météo Frances højopløselige konvektion-tilladende model over Vesteuropa med 1,3 km opløsning. Bedst i klassen for kortsigtede prognoser i Frankrig; opdateret hver tredje time.",
  "common.forecastModelDescription_ARPEGE_EU": "Météo Frances europæiske nest af ARPEGE-modellen med 10 km opløsning. Mellemfristede prognoser over Europa, opdateret fire gange dagligt.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Météo Frances globale numeriske vejrmodel med 25 km opløsning, der løber op til ca. 4 dage. Opdateret fire gange dagligt.",
  "common.forecastModelDescription_DMI_DINI": "DMI's HARMONIE DINI: en konvektionsopløsende model over det nordvestlige Europa — Danmark, Benelux, Irland, Storbritannien og Skandinavien — med 2 km opløsning, der løber op til 60 timer, opdateret otte gange dagligt. Indeholder modificerede åbne data fra DMI (CC BY 4.0).",
  "common.forecastModelDescription_EC_GDPS": "Environment Canadas globale deterministiske forudsigelsessystem: en verdensomspændende mellemfristet model med 15 km opløsning, der løber op til 10 dage, opdateret to gange dagligt.",
  "common.forecastModelDescription_EC_HRDPS": "Environment Canadas højtopløselige deterministiske forudsigelsessystem: en konvektionsopløsende model over Canada og det nordlige USA med 2,5 km opløsning, der løber op til 48 timer, opdateret fire gange dagligt.",
  "common.forecastModelDescription_EC_RDPS": "Environment Canadas regionale deterministiske forudsigelsessystem: en mellemfristet model over Nordamerika med 10 km opløsning, opdateret fire gange dagligt.",
  "common.forecastModelDescription_ECMWF_HRES": "Det Europæiske Centers for Mellemfristede Vejrprognosers flagskibsmodel i høj opløsning (IFS), bredt anset som verdens førende globale prognosesystem. Dækker hele planeten med 25 km opløsning op til 15 dage, opdateres fire gange dagligt. Indeholder modificerede åbne data fra ECMWF (CC BY 4.0).",
  "common.forecastModelDescription_GFS": "NOAA's flagskib mellemfristede globale model. Dækker hele planeten med 25 km opløsning op til 16 dage, opdateret fire gange dagligt.",
  "common.forecastModelDescription_HRRR_CONUS": "NOAA's High-Resolution Rapid Refresh: en konvektion-tilladende model over det kontinentale USA med 3 km opløsning, opdateret hver time. Bedst egnet til meget kortsigtede prognoser for tordenvejr og hårdt vejr.",
  "common.forecastModelDescription_ICON": "DWD's globale ICON-model med 13 km opløsning, der dækker hele planeten op til 7,5 dage, opdateret fire gange dagligt. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_2I": "ItaliaMeteos ICON-2I, drevet sammen med ARPAE: en konvektionsopløsende model over Italien med 2,2 km opløsning, der løber op til 72 timer, opdateret to gange dagligt. Indeholder åbne data fra ItaliaMeteo (CC BY 4.0).",
  "common.forecastModelDescription_ICON_CH1": "MeteoSwiss' ICON-CH1-EPS-kontrolkørsel: en konvektionsopløsende model over Alperne med 1 km opløsning, der løber op til 33 timer, opdateret hver tredje time.",
  "common.forecastModelDescription_ICON_CH2": "MeteoSwiss' ICON-CH2-EPS-kontrolkørsel: en konvektionsopløsende model over Alperne — Schweiz og den omkringliggende alperegion — med 2,1 km opløsning, der løber op til 120 timer, opdateret fire gange dagligt.",
  "common.forecastModelDescription_ICON_DE": "DWD's højopløselige konvektion-tilladende model over Tyskland og omkringliggende lande med 2,2 km opløsning. Kortsigtede prognoser opdateret to gange dagligt. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_EU": "DWD's europæiske nest af ICON-modellen med 7 km opløsning, der dækker Europa og Nordatlanten. Mellemfristede prognoser opdateret fire gange dagligt. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_MET_NORWAY": "Det Norske Meteorologiske Institutts åbne vejrprognosetjeneste, der blander højopløselige nordiske modeller med ECMWF-data for at give verdensomspændende prognoser op til 10 dage frem.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "AROME-nest over de franske Antiller (Guadeloupe, Martinique) med 2,5 km opløsning. Kortsigtede prognoser opdateret fire gange dagligt.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "AROME-nest over Fransk Guyana med 2,5 km opløsning. Kortsigtede prognoser opdateret fire gange dagligt.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "AROME-nest over Ny Kaledonien med 2,5 km opløsning. Kortsigtede prognoser opdateret fire gange dagligt.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "AROME-nest over Fransk Polynesien med 2,5 km opløsning. Kortsigtede prognoser opdateret fire gange dagligt.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "AROME-nest over Réunion og Mayotte med 2,5 km opløsning. Kortsigtede prognoser opdateret fire gange dagligt.",
  "common.forecastModelDescription_NAM_CONUS": "NOAA's North American Mesoscale model nest over det kontinentale USA med 5 km opløsning. Kortsigtede prognoser opdateret fire gange dagligt.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "NOAA's North American Mesoscale model, der dækker hele Nordamerika med 32 km opløsning. Opdateret fire gange dagligt.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "SmartMixins flagskibsprognose. For hver time på din placering vælger vi den bedste tilgængelige model — typisk en højopløselig regional model, hvor en sådan findes (AROME i Frankrig, ICON-D2 i Tyskland, HRRR i USA, ARPEGE Europe på tværs af kontinentet…) og falder tilbage til en global model andre steder — og udfylder så eventuelle huller fra nabokilder. Resultatet er en enkelt, sammenhængende prognose, der dækker hvor som helst i verden op til 14 dage, automatisk opdateret hver gang en af ​​de underliggende modeller opdateres.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Weatherflows proprietære globale prognose, der blander flere numeriske vejrmodeller med observationer fra dets netværk af Tempest-vejrstationer. 10-dages verdensomspændende horisont.",
  "common.forecastModelDetailTitle": "Prognosemodel",
  "common.forecastModelScopeGlobal": "Global",
  "common.forecastModelScopeGlobalDescription": "Denne model dækker hele kloden.",
  "common.forecastModelScopeRegional": "Regional",
  "common.forecastModelScopeRegionalDescription": "Denne model dækker kun en bestemt region.",
  "common.forecastModelSpecifications": "Specifikationer",
  "common.forecastNoPinLocation": "Ingen foretrukken model når denne placering — »alle andre steder« bestemmer.",
  "common.forecastNoPinStation": "Ingen foretrukken model når denne station — »alle andre steder« bestemmer.",
  "common.forecastNoPreferredModels": "Ingen foretrukne modeller angivet endnu.",
  "common.forecastOverrideElsewhere": "Dine præferencer gælder alle andre steder.",
  "common.forecastPickForLocation": "Eller vælg en til denne placering",
  "common.forecastPickForStation": "Eller vælg en til denne station",
  "common.forecastPinWinsLocation": "{model} — din første foretrukne model, der når denne placering.",
  "common.forecastPinWinsStation": "{model} — din første foretrukne model, der når denne station.",
  "common.forecastServedNowHere": "Lige nu er det {model} her",
  "common.forecastSetForLocation": "Angivet for denne placering",
  "common.forecastSetForStation": "Angivet for denne station",
  "common.forecastSettingsRowSub": "Foretrukne modeller, og hvad der gælder alle andre steder",
  "common.forecastSheetTitle": "Prognosemodel",
  "common.forecastSources": "Vejrudsigt kilder",
  "common.forecastStopUsingHere": "Brug ikke her længere",
  "common.forecastUseForLocation": "Brug {model} til denne placering",
  "common.forecastUseForStation": "Brug {model} til denne station",
  "common.forecastUsePreferred": "Brug mine foretrukne modeller",
  "common.freeAccount": "Gratis konto",
  "common.freeSubscription": "Gratis premium abonnement",
  "common.freeTrialForPeriod": "Gratis prøveperiode i {period} dage",
  "common.frequency": "Frekvens",
  "common.full": "Fuld",
  "common.fullscreen": "Fuld skærm",
  "common.getStartedFree": "Kom Gratis i Gang",
  "common.getUnlimitedAccess": "Ubegrænset adgang til:",
  "common.good": "God",
  "common.hail": "Hagl",
  "common.help": "Hjælp",
  "common.helpCategoryAccount": "Konto",
  "common.helpCategoryBilling": "Fakturering",
  "common.helpCategoryForecast": "Prognoser",
  "common.helpCategoryGettingStarted": "Kom i gang",
  "common.helpCategoryProviders": "Udbydere",
  "common.helpCategoryStations": "Stationer",
  "common.helpCategoryTroubleshooting": "Fejlfinding",
  "common.helpCenter": "Hjælpecenter",
  "common.helpCenterDescription": "Find svar på almindelige spørgsmål og lær, hvordan du får mest muligt ud af SmartMixin.",
  "common.hg": "Frostsikring",
  "common.hidden": "Skjulte",
  "common.hiddenSensors": "Skjulte sensorer",
  "common.hiddenStations": "Skjulte stationer",
  "common.hiddenStationsDescription": "Du kan fjerne en station ved at tappe øjetikonet ved siden af.",
  "common.high": "Høj",
  "common.home": "Hjem",
  "common.homeConnectService": "Ejer du en vejrstation? Tilslut din tjeneste",
  "common.homeInformation": "Hjemmeoplysninger",
  "common.homeIntroduction": "Begynd med at oprette forbindelse til dine eksterne konti for at nyde SmartMixin-funktionerne.",
  "common.homeName": "Hjemmenavn",
  "common.homeSubtitle": "Dit vejr, samlet ét sted",
  "common.horizon": "Vejrudsigtsperiode",
  "common.horizonValue": "op til {value} timer",
  "common.hour": "Time",
  "common.iDontKnowYet": "Jeg ved det endnu ikke",
  "common.indoor": "Indendørs",
  "common.lastRainEvent": "Sidste regnbegivenhed",
  "common.lastUpdate": "Sidste opdatering",
  "common.legendHeavy": "Kraftig",
  "common.legendLight": "Let",
  "common.legendLightningHelp": "Farven viser hvert lynnedslags alder over de seneste {minutes} minutter — nyeste i hvidt, ældste i mørkerødt.",
  "common.legendNewest": "Nyeste",
  "common.legendOldest": "Ældste",
  "common.legendStationsHelp": "Markørens farve afspejler værdien af den valgte måling.",
  "common.lightningDataAttribution": "Lyndata: Blitzortung.org",
  "common.lightningStrikes": "Lynnedslag",
  "common.lightningStrikesDescription": "Vis lynnedslag i realtid på kortet",
  "common.linkToSection": "Link til dette afsnit",
  "common.loading": "Henter",
  "common.location": "Placering",
  "common.locationAddedToFavorites": "Placering tilføjet til favoritter",
  "common.locationNotGranted": "Placeringstilladelse tildeles ikke. Giv adgang til din placering i enhedsindstillinger.",
  "common.locationRemovedFromFavorites": "Placering fjernet fra favoritter",
  "common.locations": "Placeringer",
  "common.low": "Lav",
  "common.manage": "Administrer",
  "common.manageAccount": "Administrer konto",
  "common.manageMySubscription": "Administrer mit abonnement",
  "common.manageSensors": "Administrer sensorer",
  "common.manageSensorsDescription": "Træk elementer for at ændre rækkefølgen af sensorer. Tryk på øjeikonet for at vise eller skjule sensorer. Tryk på et navn for at omdøbe det.",
  "common.manualBoost": "Manuel boost",
  "common.manualSetpointUntil": "Manuel sætpunkt indtil",
  "common.mapLayers": "Kortlag",
  "common.mapLegend": "Kortsignatur",
  "common.maxFavoriteLocationsReached": "Du kan kun have op til 5 yndlingssteder. Fjern den ene for at tilføje en anden.",
  "common.maximum": "Maksimum",
  "common.maxOverThePeriod": "Maksimum i perioden",
  "common.measureToDisplay": "Måling der vises",
  "common.medium": "Mellem",
  "common.meshSize": "Gitterstørrelse",
  "common.minimum": "Minimum",
  "common.minRead": "{minutes} min læsning",
  "common.modifyFavoriteStations": "Ændre yndlingsstationer",
  "common.modifyFavoriteStationsDescription": "Du kan ombestille dine yndlingsstationer ved at trække dem. Du kan også fjerne dem fra listen.",
  "common.moduleType": "Modultype",
  "common.monthTotal": "Månedstotal",
  "common.more": "Mere",
  "common.moreInformation": "Mere information",
  "common.morning": "Morgen",
  "common.myLocation": "Min placering",
  "common.nearbyWeatherStations": "Nærliggende vejrstationer",
  "common.next": "Næste",
  "common.nextHours": "Næste timer",
  "common.night": "Nat",
  "common.no": "Nej",
  "common.noAccountNeeded": "Ingen konto nødvendig",
  "common.noDataForThisPeriod": "Ingen data i denne periode",
  "common.noLocationsFound": "Ingen steder fundet",
  "common.noNetatmoWeatherStationYet": "Du har ikke en Netatmo vejrstation endnu.",
  "common.noOutdoorModule": "Der er ikke noget fungerende udendørs modul til denne station.",
  "common.noSearchResults": "Ingen artikler matcher din søgning",
  "common.noStationsFound": "Ingen stationer fundet",
  "common.noThermostatYet": "Du har ikke en termostat endnu.",
  "common.notNow": "Ikke nu",
  "common.notPurchasedYet": "Det ser ud til, at det ikke er købt endnu.",
  "common.now": "Nu",
  "common.noWeatherStation": "Ingen vejrstation",
  "common.noWeatherStationYet": "Du har ikke en vejrstation endnu.",
  "common.numberOfActiveWarnings": "{warning_count} aktive vejradvarsler",
  "common.onThisPage": "På denne side",
  "common.openSettings": "Åbne indstillinger",
  "common.orChooseMonthly": "Eller vælg månedligt:",
  "common.outdatedModule": "Dataene for dette modul er forældede.",
  "common.outdoor": "Udendørs",
  "common.outdoorTemperature": "Udetemperatur",
  "common.pageNotFound": "Side Ikke Fundet",
  "common.pageNotFoundDescription": "Siden du leder efter findes ikke eller er blevet flyttet.",
  "common.passwordUpdated": "Adgangskoden blev opdateret.",
  "common.personalWeatherIntelligence": "Din Personlige Vejrintelligens",
  "common.platformMobileApp": "Mobilapp",
  "common.platformMobileOnly": "Kun i mobilappen",
  "common.platformWebApp": "Webapp",
  "common.platformWebOnly": "Kun i webappen",
  "common.popularArticles": "Populære artikler",
  "common.premiumAccount": "Premiumkonto",
  "common.premiumDescription": "Premiumabonnementet låser op for et stort udvalg af yderligere funktioner som avanceret vejranalyse, diagramsammenligning, regionale prognosemodeller og meget mere.",
  "common.premiumFeatureAlerts": "Vejradvarsler",
  "common.premiumFeatureAnalysis": "Avanceret Vejranalyse",
  "common.premiumFeatureCharts": "Grafsammenligninger",
  "common.premiumFeatureExport": "Dataeksport",
  "common.premiumFeatureForecast": "Regionale Prognosemodeller",
  "common.premiumFeatureNotification": "Statuslinje Widget",
  "common.premiumFeatureTitle": "Premium Funktion",
  "common.premiumFeatureWidgets": "Startskærm widgets",
  "common.pressureSummary": "Trykoversigt",
  "common.previous": "Tidligere",
  "common.previousHours": "Tidligere timer",
  "common.profileUpdated": "Profil opdateret.",
  "common.purchasedNetatmoPro": "Du har tidligere købt Netatmo Pro ({date}). Det giver dig adgang til nogle af premium funktionerne. Køb abonnement til de resternde funktioner ved at vælge en af følgende.",
  "common.radarDataAttribution": "Radardata: NOAA / EUMETNET OPERA via LibreWXR",
  "common.rain": "Regn",
  "common.rainEvents": "Regnbegivenheder",
  "common.rainfallMeasurement": "Måling af nedbør",
  "common.rainRadar": "Regn radar",
  "common.rainRadarDescription": "Vis regnradaroverlejring på kortet",
  "common.rainSummary": "Nedbørsoversigt",
  "common.range": "Udsving",
  "common.recentLocations": "Nylig",
  "common.recentLocationsEmpty": "Din nylige historie er tom.",
  "common.recentStations": "Seneste stationer",
  "common.relatedArticles": "Relaterede artikler",
  "common.relay": "Styringsenhed",
  "common.removeFromFavorites": "Fjern fra favoritter",
  "common.renameSensors": "Omdøb sensorer",
  "common.resetZoom": "Nulstil zoom",
  "common.restorePurchase": "Gendan tidligere køb",
  "common.room": "Værelse",
  "common.rooms": "Værelser",
  "common.savingsPercent": "Spar {percent}%",
  "common.searchArticles": "Søg artikler...",
  "common.searchForALocation": "Søg efter en placering...",
  "common.searchForLocation": "Søg efter en beliggenhed",
  "common.searchForWeatherStation": "Søg efter en vejrstation",
  "common.searchResults": "Søgeresultater",
  "common.searchResultsEmpty": "Ingen resultater fundet.",
  "common.searchResultsFound": "{count, plural, one {# resultat fundet} other {# resultater fundet}}",
  "common.searchStationsDescription": "Indtast en by, adresse eller stednavn for at finde vejrstationer i nærheden.",
  "common.searchStationsHint": "Brug søgefeltet ovenfor til at opdage vejrstationer hvor som helst i verden.",
  "common.selectStationForComparison": "Vælg en vejrstation at sammenligne med",
  "common.selectWeatherForecastProvider": "Vælg en vejrudbyder",
  "common.serialNumber": "Serienummer",
  "common.share": "Del",
  "common.shareOutdoorMeasures": "Del dine udendørs målinger",
  "common.shareOutdoorMeasuresDescription": "Deltag i SmartMixin fællesskabet ved at dele dine udendørs målinger. Indendørs bliver aldrig delt",
  "common.shareYourWeather": "Del dit vejr",
  "common.signalStrength": "Signalstyrke",
  "common.skip": "Springe",
  "common.smartThermostat": "Smart termostat",
  "common.smartValve": "Smart ventil",
  "common.snow": "Sne",
  "common.start": "Starte",
  "common.startFreeTrial": "Start Gratis Prøveperiode",
  "common.startTime": "Starten",
  "common.station": "station",
  "common.stationAddedToFavorites": "Station tilføjet til favoritter",
  "common.stationComparison": "Station sammenligning",
  "common.stationComparisonDescription": "Sammenlign historiske vejrdata med en anden station",
  "common.stationInformation": "Station information",
  "common.stationName": "Stationsnavn",
  "common.stationObservationsDescription": "Vis de seneste observationer fra vejrstationer",
  "common.stationRemovedFromFavorites": "Station fjernet fra favoritter",
  "common.stations": "stationer",
  "common.stationsNear": "Stationer nær",
  "common.stationType": "Station type",
  "common.statusOffline": "Offline",
  "common.statusOnline": "Online",
  "common.statusStale": "Forældet",
  "common.statusSyncing": "Synkroniserer",
  "common.stillNeedHelp": "Har du stadig brug for hjælp?",
  "common.stillNeedHelpDescription": "Hvis denne artikel ikke besvarede dit spørgsmål, hjælper jeg dig gerne direkte.",
  "common.subscribeNow": "Abonner nu - uden prøveperiode",
  "common.sumOverThePeriod": "Akkumuleret over perioden",
  "common.switchToPremium": "Skift til SmartMixin premium",
  "common.temperatureShort": "Temp.",
  "common.temperatureSummary": "Temperaturoversigt",
  "common.thankYouForFeedback": "Tak for din feedback!",
  "common.thenPrice": "derefter {price}",
  "common.timeSelection": "Vælg tid",
  "common.timezone": "Tidszone",
  "common.totalDuration": "Samlet varighed",
  "common.tryAnotherLocation": "Vi kunne ikke finde vejrstationer i nærheden af denne placering. Prøv at søge i et andet område.",
  "common.unknown": "Ukendt",
  "common.untilChanged": "Indtil ændret",
  "common.untilTime": "Indtil {time}",
  "common.updateAvailable": "Opdatering tilgængelig",
  "common.updateAvailableOpenAppStore": "Tryk for at åbne App Store",
  "common.updateAvailableOpenGooglePlay": "Tryk for at åbne Google Play",
  "common.updateAvailableVersion": "Opdatering tilgængelig: v{version}",
  "common.upgrade": "Opgrader",
  "common.upgradeRequiredAndroid": "En opgradering af din applikation er påkrævet. Gå til Google Play for at opgradere.",
  "common.upgradeRequiredIos": "En opgradering af din applikation er påkrævet. Gå til Appstore for at opgradere.",
  "common.validate": "Bekræft",
  "common.validEmail": "Der kræves en gyldig emailadresse.",
  "common.very_low": "Meget lav",
  "common.viewAsList": "Liste",
  "common.viewAsPeriods": "Perioder",
  "common.visitNetatmoWebsite": "Besøg Netatmos hjemmeside",
  "common.wasArticleHelpful": "Var denne artikel nyttig?",
  "common.weatherCondition": "Vejrforhold",
  "common.weatherflowNCRain": "NC rain (Nearcast rain)",
  "common.weatherflowNCRainDescription": "NC Rain er en ekstra datakilde leveret via Tempest Weather System, drevet af Nearcast Technology. NC rain er et estimat af den gennemsnitlige nedbørsmængde omkring din Tempest på kvartersniveau",
  "common.weatherForecastModels": "Vejrudsigt modeller",
  "common.weatherIntelligencePlatform": "Vejrintelligensplatformen",
  "common.weatherMap": "Vejrkort",
  "common.weatherMapMetaDescription": "SmartMixin tilbyder interaktive vejr- og radarkort for vejrforhold verden over.",
  "common.weatherObservations": "Vejrobservationer",
  "common.weatherStation": "Vejrstation",
  "common.weatherStations": "Vejrstationer",
  "common.welcome": "Velkommen til SmartMixin!",
  "common.whenBackHome": "Hvornår vil du være hjemme igen?",
  "common.wifiStrength": "WiFi-styrke",
  "common.wind": "Vind",
  "common.windMeasurement": "Vindmåling",
  "common.windSpeed": "Vindhastighed",
  "common.windSummary": "Vindoversigt",
  "common.yearToDate": "Dette år",
  "common.yes": "Ja",
  "common.zoomImage": "Zoom på billede",
  "forecastMaps.addColor": "Tilføj farve",
  "forecastMaps.addLayer": "Tilføj lag",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.backToMaps": "Tilbage til kortene",
  "forecastMaps.browseMaps": "Gennemse kort",
  "forecastMaps.build": "Generér",
  "forecastMaps.buildCompleted": "Generering fuldført",
  "forecastMaps.builderMetaDescription": "Sammensæt dine egne prognosekort ud fra vejrmodellernes lag.",
  "forecastMaps.builderTitle": "Kortbygger",
  "forecastMaps.buildFailed": "Genereringen mislykkedes. Prøv igen.",
  "forecastMaps.buildNotPossible": "Dette kort kan ikke genereres endnu — der er ingen prognosedata tilgængelige.",
  "forecastMaps.buildProgress": "Renderer… {completed}/{total} trin",
  "forecastMaps.buildStarting": "Starter generering…",
  "forecastMaps.byModel": "Efter model",
  "forecastMaps.byZone": "Efter zone",
  "forecastMaps.colormap": "Farveskala",
  "forecastMaps.colormapCustom": "Brugerdefinerede farver",
  "forecastMaps.colormapGroupDomain": "Vejr-forudindstillinger",
  "forecastMaps.colormapGroupMatplotlib": "Videnskabelige forudindstillinger",
  "forecastMaps.colorScale": "Farveskala",
  "forecastMaps.comingSoon": "Denne visning kommer snart.",
  "forecastMaps.contourLevels": "Konturniveauer",
  "forecastMaps.countryCanada": "Canada",
  "forecastMaps.countryFrance": "Frankrig",
  "forecastMaps.countryGermany": "Tyskland",
  "forecastMaps.countryItaly": "Italien",
  "forecastMaps.countryScandinavia": "Skandinavien",
  "forecastMaps.countrySpain": "Spanien",
  "forecastMaps.countrySwitzerland": "Schweiz",
  "forecastMaps.countryUnitedStates": "USA",
  "forecastMaps.customColormapMinColors": "En brugerdefineret farveskala kræver mindst to farver",
  "forecastMaps.customExtent": "Brugerdefineret udsnit",
  "forecastMaps.deleteMap": "Slet kort",
  "forecastMaps.deleteMapBody": "\"{name}\" og de tilhørende renderinger slettes permanent.",
  "forecastMaps.deleteMapTitle": "Slet dette kort?",
  "forecastMaps.displayName": "Visningsnavn",
  "forecastMaps.downloadMp4": "Download MP4",
  "forecastMaps.downscaling": "Udtyndingsfaktor for vindfaner",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Tegn område",
  "forecastMaps.east": "Øst",
  "forecastMaps.editMap": "Redigér kort",
  "forecastMaps.exportBuilding": "Forbereder video…",
  "forecastMaps.exportError": "Videoeksporten mislykkedes. Prøv igen.",
  "forecastMaps.exportMp4": "Eksportér MP4",
  "forecastMaps.exportNotReady": "Videoen er ikke klar endnu. Prøv igen senere.",
  "forecastMaps.extentDrawHint": "Træk på kortet for at tegne området",
  "forecastMaps.extentInvalid": "Vest skal være mindre end øst, og syd mindre end nord",
  "forecastMaps.extentPanZoomHint": "Panorér og zoom, indtil området udfylder rammen",
  "forecastMaps.flipbookView": "Animation",
  "forecastMaps.forecastModel": "Prognosemodel",
  "forecastMaps.forkAndEdit": "Duplikér og redigér",
  "forecastMaps.height": "Højde (tommer)",
  "forecastMaps.hourOffset": "+{hour} t",
  "forecastMaps.invalidHexColor": "Ugyldig farve — brug #RRGGBB",
  "forecastMaps.layers": "Lag",
  "forecastMaps.layerTypeBarbs": "Vindfaner",
  "forecastMaps.layerTypeContour": "Konturlinjer",
  "forecastMaps.layerTypeFilledContour": "Udfyldte konturer",
  "forecastMaps.layerTypeMagnitude": "Størrelse",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Vektorfelt",
  "forecastMaps.leave": "Forlad",
  "forecastMaps.levelsCount": "Antal",
  "forecastMaps.levelsInvalid": "Ugyldige konturniveauer",
  "forecastMaps.levelsModeArange": "Fast trin",
  "forecastMaps.levelsModeExplicit": "Eksplicitte værdier",
  "forecastMaps.levelsModeLinspace": "Jævnt fordelt (antal)",
  "forecastMaps.levelsStep": "Trin",
  "forecastMaps.levelsValues": "Værdier",
  "forecastMaps.levelsValuesHint": "Kommaseparerede, stigende",
  "forecastMaps.localTimeHint": "Vist i din lokale tid",
  "forecastMaps.map": "Kort",
  "forecastMaps.mapDescription": "Beskrivelse",
  "forecastMaps.mapName": "Kortnavn",
  "forecastMaps.mapNameRequired": "Indtast et navn",
  "forecastMaps.mapSettings": "Kortindstillinger",
  "forecastMaps.mapView": "Interaktivt kort",
  "forecastMaps.maxLayersReached": "Dette kort har nået maksimum på {max} lag.",
  "forecastMaps.maxValue": "Maksimumværdi",
  "forecastMaps.memoryBudgetExceeded": "Opløsningen overskrider renderingsbudgettet — reducér DPI eller højde",
  "forecastMaps.memoryBudgetUsage": "Renderingsbudget: {percent}%",
  "forecastMaps.metaDescription": "Animerede prognosekort genereret ud fra vejrmodellernes kørsler.",
  "forecastMaps.metric": "Måling",
  "forecastMaps.metricRequired": "Vælg en måling",
  "forecastMaps.metricUnavailable": "Ikke tilgængelig for denne model",
  "forecastMaps.minBelowMax": "Min skal være mindre end maks",
  "forecastMaps.minMaxRequired": "Min- og maks-værdier er påkrævet for denne lagtype",
  "forecastMaps.minValue": "Minimumværdi",
  "forecastMaps.modelNoRun": "Ingen fuldført kørsel endnu",
  "forecastMaps.moveLayerDown": "Flyt ned",
  "forecastMaps.moveLayerUp": "Flyt op",
  "forecastMaps.myMaps": "Mine kort",
  "forecastMaps.nanClipToMin": "Begræns til min",
  "forecastMaps.nanMask": "Maskér",
  "forecastMaps.nanPolicy": "Manglende data",
  "forecastMaps.nanSkip": "Spring over",
  "forecastMaps.newMap": "Nyt kort",
  "forecastMaps.noCompletedRun": "Dette kort er ikke genereret endnu. Kig tilbage snart.",
  "forecastMaps.noLayers": "Ingen lag endnu. Tilføj et lag for at komme i gang.",
  "forecastMaps.noMapsAvailable": "Der er endnu ingen tilgængelige prognosekort.",
  "forecastMaps.north": "Nord",
  "forecastMaps.opacity": "Gennemsigtighed",
  "forecastMaps.overlayLegend": "Signaturforklaring",
  "forecastMaps.pause": "Pause",
  "forecastMaps.play": "Afspil",
  "forecastMaps.pointValueError": "Prognosen for dette punkt kunne ikke indlæses.",
  "forecastMaps.pointValueLoading": "Indlæser prognose…",
  "forecastMaps.pointValueUnavailable": "Ingen data for dette tidspunkt.",
  "forecastMaps.presets": "Forudindstillinger",
  "forecastMaps.preview": "Forhåndsvisning",
  "forecastMaps.previewEmptyHint": "Konfigurér mindst ét gyldigt lag for at rendere en forhåndsvisning.",
  "forecastMaps.previewFailed": "Forhåndsvisningen mislykkedes",
  "forecastMaps.previewHour": "Prognosetime",
  "forecastMaps.previewRendering": "Renderer forhåndsvisning…",
  "forecastMaps.projection": "Projektion",
  "forecastMaps.projectionLambertConformal": "Lambert konform",
  "forecastMaps.projectionMercator": "Mercator",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stereografisk",
  "forecastMaps.regionEurope": "Europa",
  "forecastMaps.regionNorthAmerica": "Nordamerika",
  "forecastMaps.removeColor": "Fjern farve",
  "forecastMaps.removeLayer": "Fjern lag",
  "forecastMaps.retry": "Prøv igen",
  "forecastMaps.run": "Kørsel: {run}",
  "forecastMaps.save": "Gem",
  "forecastMaps.selectExtentOnMap": "Vælg område på kortet",
  "forecastMaps.south": "Syd",
  "forecastMaps.title": "Prognosekort",
  "forecastMaps.uMetric": "U-komponent",
  "forecastMaps.unitConversion": "Enhedskonvertering",
  "forecastMaps.unitNone": "Ingen",
  "forecastMaps.unsavedChangesBody": "Du har ugemte ændringer. Forlad og kassér dem?",
  "forecastMaps.unsavedChangesTitle": "Ugemte ændringer",
  "forecastMaps.useCurrentView": "Brug nuværende visning",
  "forecastMaps.useModelDomain": "Fra: hele modellens domæne bruges",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "U- og V-målinger skal være forskellige",
  "forecastMaps.validTime": "Gyldig: {time}",
  "forecastMaps.valueBetween": "Skal være mellem {min} og {max}",
  "forecastMaps.variable": "Variabel",
  "forecastMaps.viewMap": "Se kort",
  "forecastMaps.vMetric": "V-komponent",
  "forecastMaps.west": "Vest",
  "forecastMaps.windAnimation": "Vindanimation",
  "intro.locationDescription": "Aktivér lokationsadgang for at få præcise vejrudsigter tilpasset dit nøjagtige område — ikke flere vejrudsigter, som passer til alle.",
  "intro.locationTitle": "Prognoser skabt til dig",
  "intro.notificationDescription": "Slå notifikationer til og få rettidige advarsler om vejraf ændringer, der betyder noget for dig — regn, sne eller ekstreme forhold, lige når du har brug for det.",
  "intro.notificationsTitle": "Gå aldrig glip af en vejrændring",
  "intro.readyDescription": "Nyd præcise prognoser, realtidsvejrops og stationsdata fra hele verden — alt i én kraftfuld app.",
  "intro.readyTitle": "Du er klar!",
  "intro.welcomeDescription": "Få hyperlokale prognoser fra førende vejragenter — plus adgang til over 40.000 vejstationer verden over for at se de faktiske forhold, både nu og tidligere.",
  "intro.welcomeTitle": "Dit vejr, genopfundet",
  "landing.alerts": "Advarsler",
  "landing.alertsDescription": "Opret dine egne alarmer og få besked, så snart de udløses.",
  "landing.featureAlertsDescription": "Indstil tilpassede advarsler for forhold, der interesserer dig—temperatur, vind, nedbør og mere.",
  "landing.featureAlertsTitle": "Smarte advarsler",
  "landing.featureAnalyticsDescription": "Dyk ned i dine data med interaktive diagrammer, side-om-side sammenligninger og trendanalyser, der går ud over grundlæggende målinger.",
  "landing.featureAnalyticsTitle": "Kraftfuld analyse",
  "landing.featureExportDescription": "Download dine data i CSV-format til analyse i Excel, integration med andre systemer eller sikkerhedskopiering.",
  "landing.featureExportTitle": "Eksporter overalt",
  "landing.featureForecastDescription": "Sammenlign prognoser fra over 10 vejrmodeller inklusive GFS, ECMWF, ICON og flere for at se, hvilken der fungerer bedst for din placering.",
  "landing.featureForecastTitle": "Prognosesammenligning",
  "landing.featureHistoryDescription": "Få adgang til historiske data med time-, dags- og månedsskala. Eksporter til CSV til forskning eller personlige arkiver.",
  "landing.featureHistoryTitle": "Rig historik",
  "landing.featureMultiBrandDescription": "Tilslut stationer fra Netatmo, Ecowitt, Ambient Weather, Davis, WeatherFlow og flere—alt i ét dashboard.",
  "landing.featureMultiBrandTitle": "Multi-mærke support",
  "landing.featuresSubtitle": "Designet for vejrentusiaster, der kræver mere end en grundlæggende vejrstationsapp.",
  "landing.featuresTitle": "Alt hvad du behøver for at analysere vejret",
  "landing.finalCtaButton": "Opret gratis konto",
  "landing.finalCtaSubtitle": "Slut dig til tusindvis af vejrentusiaster, der stoler på SmartMixin til deres vejrdata.",
  "landing.finalCtaTitle": "Klar til at forbedre din vejroplevelse?",
  "landing.forecastDescription": "Få adgang til nogle af de bedste vejrudsigtsmodeller, og sammenlign dem for at få din egen idé om, hvordan vejret bliver.",
  "landing.forecasts": "Prognoser",
  "landing.heroCta": "Start gratis",
  "landing.heroDescription": "Kombiner flere vejrstationer fra ethvert mærke, sammenlign prognosemodeller og analyser dine data med detaljerede diagrammer og eksporter.",
  "landing.heroSecondaryCta": "Udforsk kortet",
  "landing.heroTagline": "For vejrentusiaster",
  "landing.heroTitle": "Alle vejrdata. Én platform.",
  "landing.pricingFeatureAdvancedMetrics": "Avancerede målinger",
  "landing.pricingFeatureAlerts": "Tilpassede advarsler",
  "landing.pricingFeatureExport": "Dataeksport (CSV)",
  "landing.pricingFeatureForecastComparison": "Prognosesammenligning",
  "landing.pricingFeatureForecasts": "Prognosemodeller",
  "landing.pricingFeatureForecastsFreeTier": "1 model",
  "landing.pricingFeatureForecastsPremiumTier": "Alle modeller (10+)",
  "landing.pricingFeatureReports": "Analyser og rapporter",
  "landing.pricingFeatureStationComparison": "Stationssammenligning",
  "landing.pricingFeatureWidgets": "Startskærm-widgets",
  "landing.pricingFeatureYearOverYear": "År-til-år-analyse",
  "landing.pricingFree": "Gratis",
  "landing.pricingFreeCta": "Kom i gang",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Mest populær",
  "landing.pricingPremium": "Premium",
  "landing.pricingPremiumCta": "Kom i gang",
  "landing.pricingPremiumDescription": "Fra 1,99 €/måned — abonner på web, App Store eller Google Play",
  "landing.pricingSubtitle": "Start gratis, opgrader når du har brug for mere.",
  "landing.pricingTitle": "Enkel, gennemsigtig prissætning",
  "landing.smartMixinDescription": "SmartMixin er en applikation, der giver adgang til din vejrstation og 40K+ andre stationer over hele verden. Det hjælper dig med at se og forstå vejrdata.",
  "landing.statBrands": "Understøttede mærker",
  "landing.statForecasts": "Prognosemodeller",
  "landing.statStations": "Vejrstationer",
  "landing.supportedDevices": "Understøttede enheder",
  "landing.supportedDevicesDescription": "Ud over stationerne fra World Meteorological Organization understøtter SmartMixin et voksende antal vejrstationsmærker.",
  "landing.supportedDevicesNote": "Plus mere end 40.000 offentlige stationer fra Verdens Meteorologiske Organisation",
  "landing.supportedDevicesSubtitle": "Tilslut vejrstationer fra førende mærker og se alle data ét sted.",
  "landing.supportedDevicesTitle": "Fungerer med dine stationer",
  "landing.thermostatDescription": "Forbind din Netatmo-termostat for at sammenligne varmemønstre med udendørs forhold.",
  "landing.thermostatManufacturers": "Termostatproducenter understøttes også til at korrelere opvarmning med udendørsforhold.",
  "landing.thermostatTitle": "Smart home-integration",
  "landing.weatherAnalysis": "Vejranalyse",
  "landing.weatherAnalysisDescription": "SmartMixin kommer med masser af datavisualisering, der lader dig analysere vejrdata.",
  "landing.weatherAssistant": "Din vejrassistent",
  "landing.weatherAssistantDescription": "Uanset om du er interesseret i aktuelle, historiske eller forventede vejrforhold, giver SmartMixin adskillige indsigter, når du har brug for dem.",
  "landing.weatherForecastModels": "Vejrudsigtsmodeller",
  "landing.weatherForecastModelsDescription": "SmartMixin giver adgang til de mest nøjagtige vejrudsigtsmodeller. Du kan nemt sammenligne deres prognoser og lave din egen idé.",
  "landing.weatherMap": "Vejrkort",
  "landing.weatherMapDescription": "Gennemse kortet og visualiser, hvordan vejret er overalt på kloden.",
  "network.cancelError": "Forespørgslen er blevet annulleret",
  "network.connectionError": "Serveren er ikke tilgængelig",
  "network.networkError": "Netværket er ikke tilgængeligt",
  "network.serverError": "Der er noget galt...",
  "network.timeoutError": "Forbindelsen fik timeout",
  "network.unknownError": "Ukendt fejl",
  "providerHints.ambientWeatherApiKey": "Oprettet i kontoindstillingerne på ambientweather.net.",
  "providerHints.davisApiSecret": "Vises kun én gang ved oprettelse af V2 API-nøglen — opbevar sikkert.",
  "providerHints.davisV2ApiKey": "Fra V2 API-nøglesiden på weatherlink.com.",
  "providerHints.ecowittApi": "Fra API-siden i din Ecowitt-konto.",
  "providerHints.ecowittApp": "Programnøglen, også fra din Ecowitt-konto.",
  "providerHints.myAcuriteCredentialsBanner": "Brug e-mail og adgangskode til din My AcuRite-konto — ikke SmartMixin-login.",
  "providerHints.myAcuriteEmail": "E-mailadressen på din My AcuRite-konto — ikke dit SmartMixin-login.",
  "providerHints.myAcuritePassword": "Adgangskoden til din My AcuRite-konto.",
  "providerHints.weatherflowToken": "Personlig token fra tempestwx.com → indstillinger → dataautorisationer.",
  "providerHints.wundergroundEditKey": "Brug en anden nøgle",
  "providerHints.wundergroundKey": "En lang streng fra API-nøglesiden i din Weather Underground-konto — ikke din wunderground.com-adgangskode.",
  "providerHints.wundergroundKeyExample": "f.eks. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API-nøgle verificeret",
  "providerHints.wundergroundKeyVerifying": "Kontrollerer nøgle…",
  "providerHints.wundergroundNoStationsNearby": "Ingen stationer fundet i nærheden. Prøv at indtaste et stations-ID direkte.",
  "providerHints.wundergroundStationId": "Et hvilket som helst Weather Underground-stations-ID — dit eget eller en offentlig station tæt på dig.",
  "providerHints.wundergroundStationIdExample": "f.eks. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Hent din Ambient Weather API-nøgle.",
  "providerIntro.davisStep2": "Hent din Davis V2 API-nøgle og API-hemmelighed.",
  "providerIntro.ecowittStep2": "Hent din Ecowitt API-nøgle og programnøgle.",
  "providerIntro.getStarted": "Kom i gang",
  "providerIntro.myAcuriteStep2": "Brug e-mail og adgangskode til din eksisterende My AcuRite-konto.",
  "providerIntro.netatmoEnergyStep2": "Log ind på Netatmo, når du bliver bedt om det — ingen API-nøgle nødvendig.",
  "providerIntro.netatmoWeatherStep2": "Log ind på Netatmo, når du bliver bedt om det — ingen API-nøgle nødvendig.",
  "providerIntro.signupBanner": "Næsten færdig — opret din gratis SmartMixin-konto for at forbinde {provider}.",
  "providerIntro.step1": "Log ind på din SmartMixin-konto (IKKE dit {provider}-login).",
  "providerIntro.step3EmailPassword": "Indtast dem her.",
  "providerIntro.step3KeyOrToken": "Indsæt den her.",
  "providerIntro.step3OAuth": "Godkend SmartMixin i popup-vinduet.",
  "providerIntro.step3Wunderground": "Indsæt din API-nøgle, og vælg derefter en station i nærheden, eller indtast et hvilket som helst stations-ID.",
  "providerIntro.title": "Forbind {provider}",
  "providerIntro.weatherflowStep2": "Hent din personlige Tempest-token.",
  "providerIntro.wundergroundBrowsePublic": "Har du ingen station? Gennemse offentlige",
  "providerIntro.wundergroundFindNearby": "Find stationer i nærheden",
  "providerIntro.wundergroundOrEnterId": "Eller indtast et stations-ID",
  "providerIntro.wundergroundStep2": "Hent din Weather Underground API-nøgle. Du kan derefter forbinde enhver station — din egen eller en offentlig.",
  "reports.agroMeteorology": "Agrometeorologi",
  "reports.analysis": "Analyse",
  "reports.annualCumulativeRainfallComparison": "Årlig kumulativ nedbør sammenligning",
  "reports.annualHeatingDurationComparison": "Sammenligning af årlig opvarmningsvarighed",
  "reports.annualHeatingEfficiency": "Årlig opvarmningseffektivitet",
  "reports.annualIndoorComparison": "Årlig indendørssammenligning",
  "reports.annualIndoorReport": "Årlig indendørsrapport",
  "reports.annualOutdoorComparison": "Årlig udendørssammenligning",
  "reports.annualOutdoorReport": "Årlig udendørsrapport",
  "reports.annualReport": "Årlig rapport",
  "reports.annualSolarReport": "Årlig sol rapport",
  "reports.annualWaterBalance": "Årlig vand balance",
  "reports.annualWaterBalanceCarryOver": "Overfør forrige år",
  "reports.annualWaterBalanceDescription": "Vand balance (simplificeret version, kun regn og fordampning anvendes) hjælper med at styre vandforsyning",
  "reports.avgHumidity": "Gennemsnitlig luftfugtighed",
  "reports.avgMaxTemperature": "Gennemsnitlig T°maks",
  "reports.avgMetric": "Gennemsnit – {metric}",
  "reports.avgMinTemperature": "Gennemsnitlig T°min",
  "reports.avgPressure": "Gennemsnitligt lufttryk",
  "reports.avgTemperature": "Gennemsnitstemperatur",
  "reports.climateNormalPeriodOfRecord": "Måleperiode ({years} år)",
  "reports.climateNormals": "Klimanormaler",
  "reports.climateNormalStandardLabel": "Standardnormal ({period})",
  "reports.climateTrendPerDecade": "Temperaturtendens: {value} pr. årti over {years} år",
  "reports.coldestMonthRanking": "Koldeste {month} nogensinde målt",
  "reports.comfortable": "Komfortabelt (45% {lessThan} luftfugtighed ≤ 60%)",
  "reports.cumulativeRainfall": "Kumulativ nedbør",
  "reports.cumulativeRainfallDescription": "Følg den samlede nedbør, der akkumuleres over den valgte periode.",
  "reports.dailyMaxRainfall": "Daglig maks. nedbør",
  "reports.dataExport": "Eksporter data",
  "reports.dataExportXlsxFormatDescription": "Eksporterer alle vejrstationes data i Excel-format (* .xlsx). Når du har klikket på knappen, vil du efter et par minutter modtage en email med de behandlede data.",
  "reports.daysOfData": "{days, plural, one {# dags data} other {# dages data}}",
  "reports.daysWithFrost": "Dage med frostvejr",
  "reports.daysWithHeavyRain": "Dage med kraftig regn (≥ {threshold})",
  "reports.daysWithoutThaw": "Dage uden tøvejr",
  "reports.daysWithStrongFrost": "Dage med hård frost",
  "reports.emailSent": "Der er sendt en email til dig",
  "reports.frostDays": "Frostdage",
  "reports.grasslandTemperatureSum": "Græsmarkstemperatursum",
  "reports.grasslandTemperatureSumDescription": "Hvis det samlede {threshold} overskrides om foråret, vil det bæredygtige start af vegetation være opnået",
  "reports.growingDegreeDays": "Vækstgraddage",
  "reports.highPressure": "Højt lufttryk (gns. lufttryk ≥ 1013 mbar)",
  "reports.iceDays": "Isdage",
  "reports.indoorReport": "Indendørsrapport",
  "reports.keyFacts": "Nøglefakta",
  "reports.longestDrySpell": "Længste tørre periode",
  "reports.longestRunOfRainyDays": "Længste forløb af regnvejrsdage",
  "reports.longestRunWithoutRun": "Længste forløb uden regn",
  "reports.longestWetSpell": "Længste våde periode",
  "reports.lowPressure": "Lavt lufttryk (gns. lufttryk {lessThan} 1013 mbar)",
  "reports.maxHumidity": "Maks. luftfugtighed",
  "reports.maxMetric": "Maksimum – {metric}",
  "reports.maxPressure": "Maks. lufttryk",
  "reports.maxPressureMagnitude24h": "Forskel i maksimumslufttryk (/24t)",
  "reports.maxTemperature": "Maksimumstemperatur",
  "reports.maxTempGreaterThan": "T°maks. ≥",
  "reports.maxTempMagnitude24h": "Forskel i maksimumstemperatur (/24t)",
  "reports.minHumidity": "Min. luftfugtighed",
  "reports.minMetric": "Minimum – {metric}",
  "reports.minPressure": "Min. lufttryk",
  "reports.minPressureMagnitude24h": "Forskel i mimimumslufttryk (/24t)",
  "reports.minTemperature": "Minimumstemperatur",
  "reports.minTempMagnitude24h": "Forskel i minimumstemperatur (/24t)",
  "reports.monthlyAverageCountdown": "{days, plural, one {# dag mere} other {# dage mere}} denne måned",
  "reports.monthlyAverageCountdownDetail": "Så vises månedens gennemsnit og placering.",
  "reports.monthlyAverageRule": "Månedlige gennemsnit og placeringer vises, når en kalendermåned har {days, plural, one {# dag} other {# dage}} registreret.",
  "reports.monthlyHeatingEfficiency": "Månedlig varmeeffektivitet",
  "reports.monthlyIndoorReport": "Månedlig indendørsrapport",
  "reports.monthlyOutdoorReport": "Månedlig udendørsrapport",
  "reports.monthlyReport": "Månedlig rapport",
  "reports.monthlySolarReport": "Månedlig solrapport",
  "reports.monthlyWindReport": "Månedlig vindrapport",
  "reports.monthsOfData": "{months} måneders data",
  "reports.numberOfDays": "Antal dage",
  "reports.onThisDayInHistory": "På denne dag i historien",
  "reports.outdoorReport": "Udendørsrapport",
  "reports.overviewSection": "Oversigt",
  "reports.rainfall": "Nedbør",
  "reports.rainyDays": "Nedbørsdage",
  "reports.recordDailyRain": "Vådeste dag",
  "reports.recordHigh": "Varmerekord",
  "reports.recordLow": "Kulderekord",
  "reports.recordsAndClimatology": "Rekorder og klima",
  "reports.recordsSince": "Rekorder siden {date}",
  "reports.recordWindGust": "Stærkeste vindstød",
  "reports.relativelyWet": "Relativt vådt (60% {lessThan} luftfugtighed ≤ 80%)",
  "reports.sectionReportCount": "{count, plural, one {# rapport} other {# rapporter}}",
  "reports.sendEmail": "Send email",
  "reports.summerDays": "Sommerdage",
  "reports.tooDry": "For tørt (luftfugtighed ≤ 45%)",
  "reports.tooWet": "For vådt (luftfugtighed {greaterThan} 80%)",
  "reports.tropicalNights": "Tropenætter",
  "reports.unlockPremiumSubtitle": "Inkluderet i SmartMixin Premium",
  "reports.unlockPremiumTitle": "Lås {count, plural, one {# premiumfunktion} other {# premiumfunktioner}} op",
  "reports.warmestMonthRanking": "Varmeste {month} nogensinde målt",
  "reports.waterBalance": "Vandbalance",
  "reports.yearsOfData": "{years} års data",
  "reports.yearToDateTemperatureComparison": "Temperatursammenligning hidtil i år",
  "sensors.aqiByChannel": "AQI pr. kanal",
  "sensors.bgtSensors": "Sortglobe & WBGT",
  "sensors.cameraFeed": "Kamera",
  "sensors.compareAqi": "Sammenlign AQI",
  "sensors.compareHumidity": "Sammenlign luftfugtighed",
  "sensors.compareMoisture": "Sammenlign jordfugtighed",
  "sensors.comparePm25": "Sammenlign PM2.5",
  "sensors.compareTemperatures": "Sammenlign temperaturer",
  "sensors.depthByChannel": "Dybde pr. kanal",
  "sensors.heatStressExtreme": "Ekstrem varmestress",
  "sensors.heatStressModerate": "Moderat varmestress",
  "sensors.heatStressNone": "Ingen varmestress",
  "sensors.heatStressStrong": "Stærk varmestress",
  "sensors.heatStressVeryStrong": "Meget stærk varmestress",
  "sensors.humidityByChannel": "Luftfugtighed pr. kanal",
  "sensors.indoorAirQualityPm": "PM2.5 & PM10 AQI",
  "sensors.indoorClimate": "Indeklima",
  "sensors.indoorCo2Levels": "CO2-niveauer",
  "sensors.indoorTemperatureAndHumidity": "Temperatur og luftfugtighed",
  "sensors.last24Hours": "24 timer",
  "sensors.last30Days": "30 dage",
  "sensors.last7Days": "7 dage",
  "sensors.leafTemperatureByChannel": "Bladtemperatur pr. kanal",
  "sensors.leafWetnessByChannel": "Bladfugtighed pr. kanal",
  "sensors.lightningSensor": "Lyn",
  "sensors.moistureByChannel": "Jordfugtighed pr. kanal",
  "sensors.noDataAvailable": "Ingen data tilgængelige",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 pr. kanal",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Vælg kanal",
  "sensors.sensorDetailDescription": "Se historiske data og tendenser for dine sensorkanaler.",
  "sensors.sensorHistory": "Sensorhistorik",
  "sensors.soilConductivityByChannel": "Ledningsevne pr. kanal",
  "sensors.soilTemperatureByChannel": "Jordtemperatur pr. kanal",
  "sensors.strikesToday": "Nedslag i dag",
  "sensors.temperatureByChannel": "Temperatur pr. kanal",
  "sensors.viewChart": "Vis graf",
  "settings.about": "Om",
  "settings.aboutDescription": "Licensaftale, fortrolighedspolitik",
  "settings.account": "Konto",
  "settings.accountDescription": "Profil, ændring af adgangskode",
  "settings.accountIntro": "Data vedr. din konto:",
  "settings.accountOnHoldTitle": "Konto sat på pause",
  "settings.accountSection": "Konto",
  "settings.addForecastModel": "Tilføj en model",
  "settings.appearance": "Udseende",
  "settings.appearanceDescription": "Tema og visningsindstillinger",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "arabisk",
  "settings.atYourStations": "Tilgængelige ved dine stationer",
  "settings.availableServices": "Tilgængelige",
  "settings.bulgarian": "bulgarsk",
  "settings.cannotDisconnectLastAccount": "Kan ikke afbryde din eneste loginmetode. Tilføj venligst en anden loginmetode først.",
  "settings.catalan": "catalansk",
  "settings.changeEmail": "Skift e-mail",
  "settings.changePassword": "Ændr kodeord",
  "settings.chartGestures": "Gestus på diagrammer",
  "settings.chartGesturesDescription": "Strygning på diagrammer ændrer tidsperioden, klemning af diagram ændrer tidsskala",
  "settings.choiceCount": "{count, plural, one {# tilgængelig} other {# tilgængelige}}",
  "settings.connect": "Tilslut",
  "settings.connected": "Tilsluttet",
  "settings.connectedAccounts": "Tilknyttede konti",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Tilsluttet",
  "settings.connectedSince": "Tilsluttet siden {date}",
  "settings.connectionSection": "Forbindelse",
  "settings.connectionSuccess": "{provider}-konto tilsluttet",
  "settings.contactUs": "Kontakt os",
  "settings.contactUsDescription": "Få hjælp eller send feedback",
  "settings.coverageLoading": "Beregner hvilke af dine stationer hver model dækker…",
  "settings.croatian": "kroatisk",
  "settings.currentPassword": "Nuværende adgangskode",
  "settings.czech": "tjekkisk",
  "settings.dailyDetailByPeriods": "Dagsdetaljer efter perioder",
  "settings.dailyDetailByPeriodsDescription": "Gruppér de 24 timer i nat, morgen, eftermiddag og aften — den samme opdeling som dagens opsummering bruger.",
  "settings.dangerZone": "Farezone",
  "settings.danish": "dansk",
  "settings.dark": "Mørkt tema",
  "settings.dataDisplay": "Datavisning",
  "settings.dateAndTime": "Dato og tid",
  "settings.disconnect": "Afbryd",
  "settings.disconnectConfirmation": "Er du sikker på, at du vil afbryde din {provider}-konto?",
  "settings.disconnectionSuccess": "{provider}-konto afbrudt",
  "settings.disconnectProviderDescription": "Stopper synkroniseringen. Din historik bevares.",
  "settings.donateButton": "Giv en donation",
  "settings.donateDescription": "SmartMixin er bygget af et lille team. Hvis du finder den nyttig, kan du støtte udviklingen med en engangsdonation på et hvilket som helst beløb. Det er en gave — den ændrer ikke dit abonnement og låser ikke nogen funktioner op.",
  "settings.donateSuccessBody": "Din donation hjælper med at holde SmartMixin kørende og gøre den bedre. Vi sætter stor pris på det.",
  "settings.donateSuccessTitle": "Tak for din støtte!",
  "settings.donateTitle": "Støt SmartMixin",
  "settings.dragToReorder": "Træk for at omarrangere",
  "settings.dutch": "hollandsk",
  "settings.emailChange": "Skift e-mailadresse",
  "settings.emailChangeConfirmation": "Bekræftelse af e-mailændring",
  "settings.emailChangeFailure": "Linket til e-mailændring er ugyldigt eller udløbet.",
  "settings.emailChangeSuccess": "Din e-mail er blevet ændret til {newEmail}.",
  "settings.emailChangeVerificationSent": "En bekræftelses-e-mail er blevet sendt til din nye e-mailadresse. Tjek venligst din indbakke og klik på linket for at bekræfte ændringen.",
  "settings.english": "engelsk",
  "settings.everywhereElse": "Alle andre steder",
  "settings.everywhereElseFoot": "Bruges ved enhver station, dine foretrukne modeller ikke når.",
  "settings.everywhereElsePick": "Vælg én",
  "settings.fallbackBlend": "SmartMixin-blanding",
  "settings.fallbackBlendSub": "Kombinerer flere modeller, hver dér hvor den er stærkest.",
  "settings.fallbackEcmwf": "ECMWF",
  "settings.fallbackEcmwfSub": "ECMWF HRES overalt hvor den rækker.",
  "settings.fallbackGfs": "GFS",
  "settings.fallbackGfsSub": "NOAA's globale model. Det, alle konti bruger i dag.",
  "settings.fallbackResolution": "Højeste opløsning",
  "settings.fallbackResolutionSub": "Det fineste gitter, der er tilgængeligt ved hver station.",
  "settings.forecastModels": "Prognosemodeller",
  "settings.freeBannerBody": "Gratis konti får GFS overalt — foretrukne modeller og »alle andre steder« træder i kraft, så snart du abonnerer.",
  "settings.freeBannerTitle": "Præferencer gælder med Premium",
  "settings.french": "fransk",
  "settings.german": "tysk",
  "settings.gestures": "Gestik",
  "settings.greek": "græsk",
  "settings.helpCenter": "Hjælpecenter",
  "settings.helpCenterDescription": "Ofte stillede spørgsmål og vejledninger",
  "settings.hungarian": "ungarsk",
  "settings.integrationsSection": "Integrationer",
  "settings.italian": "italiensk",
  "settings.japanese": "japansk",
  "settings.korean": "koreansk",
  "settings.language": "Sprog",
  "settings.languageDescription": "Foretrukket sprog",
  "settings.light": "Lyst tema",
  "settings.measurementUnits": "Måleenheder",
  "settings.newEmailAddress": "Ny e-mailadresse",
  "settings.newPassword": "Ny adgangskode",
  "settings.newPasswordAgain": "Ny adgangskode (gentag)",
  "settings.norwegian": "norsk",
  "settings.notConnected": "Ikke tilsluttet",
  "settings.notificationsSection": "Notifikationer",
  "settings.oldPassword": "Nuværende adgangskode",
  "settings.ongoingNotificationEnabled": "Aktiver permanent notifikation",
  "settings.ongoingNotificationMetrics": "Viste målinger",
  "settings.ongoingNotificationPermissionRequired": "Notifikationstilladelse kræves",
  "settings.ongoingNotificationPreviewHint": "Forhåndsvisning — slå widgetten til for at vise den",
  "settings.ongoingNotificationStation": "Vejrstation",
  "settings.ongoingNotificationStatusBar": "Statuslinje",
  "settings.passwordChange": "Ændring af adgangskode",
  "settings.passwordChangeDescription": "Hold din konto sikker",
  "settings.pickerShowAll": "Vis hele kataloget",
  "settings.pickerUnreachable": "{count, plural, one {# model mere når} other {# modeller mere når}} ingen af dine stationer",
  "settings.pinInUse": "I brug",
  "settings.pinShadowed": "Bruges aldrig — en model ovenfor dækker alle dine stationer",
  "settings.pinSlots": "{used} af {max} · tryk for at vælge",
  "settings.pinSlotsFull": "Alle {max} pladser er i brug. Fjern én for at tilføje en anden.",
  "settings.pinsUncoveredCount": "{used} af dine {count, plural, one {# station} other {# stationer}}: ingen foretrukken model når {used, plural, one {den} other {dem}} — »alle andre steder« bestemmer.",
  "settings.pinsUncoveredNamed": "{stations}: ingen foretrukken model når {count, plural, one {den} other {dem}} — »alle andre steder« bestemmer.",
  "settings.pinUnreachable": "Bruges aldrig — den når ingen af dine stationer",
  "settings.pinUsedAt": "Bruges ved {stations}",
  "settings.pinUsedAtAll": "{count, plural, one {Bruges ved din station} other {Bruges ved alle # stationer}}",
  "settings.pinUsedAtSome": "Bruges ved {used} af {count, plural, one {# station} other {# stationer}}",
  "settings.polish": "polsk",
  "settings.portuguese": "portugisisk",
  "settings.preferencesSection": "Præferencer",
  "settings.preferredModels": "Foretrukne modeller",
  "settings.preferredModelsAll": "Én liste, alle stationer",
  "settings.preferredModelsOne": "Én liste, gælder overalt",
  "settings.premium": "Premium",
  "settings.premiumActive": "Aktiv",
  "settings.premiumAnnualThenPrice": "Derefter 9,99 €/år",
  "settings.premiumAnnualTrialInfo": "Start med en gratis prøveperiode på {days} dage",
  "settings.premiumCurrentPlan": "Nuværende abonnement",
  "settings.premiumDescription": "Lås op for premium-funktioner",
  "settings.premiumDownloadApp": "Download appen for at abonnere:",
  "settings.premiumExpiresOn": "Fornyes {date}",
  "settings.premiumFreePlan": "Gratis",
  "settings.premiumInactive": "Ikke abonneret",
  "settings.premiumManageWebSubscription": "Administrer dit abonnement, opdater betalingsmetode eller annuller.",
  "settings.premiumPremiumPlan": "Premium",
  "settings.premiumSubscribeAnnual": "Årligt — 9,99 €/år",
  "settings.premiumSubscribedOn": "Abonneret på {platform}",
  "settings.premiumSubscribeMonthly": "Månedligt — 1,99 €/måned",
  "settings.premiumSubscribeOnWeb": "Abonner nu for at låse op for alle premium-funktioner.",
  "settings.premiumSubscriptionSuccess": "Dit abonnement er aktiveret! Nyd alle premium-funktioner.",
  "settings.premiumSubscriptionSuccessTitle": "Velkommen til Premium!",
  "settings.premiumWebappNotice": "Abonnementer kan kun købes via SmartMixin-mobilappen på iOS eller Android.",
  "settings.privacyPolicy": "Privatlivspolitik",
  "settings.profile": "Profil",
  "settings.removePreferredModel": "Fjern {model} fra dine foretrukne modeller",
  "settings.resetForecastPreference": "Nulstil",
  "settings.resetForecastPreferenceHint": "Rydder dine foretrukne modeller og vender tilbage til SmartMixins standard.",
  "settings.russian": "russisk",
  "settings.seePremium": "Se Premium",
  "settings.serbian": "serbisk",
  "settings.servedNowMany": "Lige nu: GFS {count, plural, one {ved din station} other {ved alle # stationer}}.",
  "settings.servedNowNone": "Lige nu: GFS overalt.",
  "settings.settings": "Indstillinger",
  "settings.signedInAs": "Logget ind som",
  "settings.slovak": "slovakisk",
  "settings.smallDecimals": "Små decimaler",
  "settings.smallDecimalsDescription": "Vis decimalcifre i en mindre størrelse",
  "settings.socialConnectionsIntro": "Tilknyt dine sociale konti for hurtig login. Du kan tilslutte eller afbryde konti når som helst.",
  "settings.spanish": "spansk",
  "settings.statusBarWidget": "Statuslinje-widget",
  "settings.statusBarWidgetDescription": "Altid synlige vejrdata",
  "settings.subscriptionSection": "Abonnement",
  "settings.supportSection": "Support",
  "settings.swedish": "svensk",
  "settings.systemTheme": "Systemtema",
  "settings.termsOfService": "Servicevilkår",
  "settings.turkish": "tyrkisk",
  "settings.ukrainian": "ukrainsk",
  "settings.units": "Enheder",
  "settings.unitsDescription": "Måleenheder, der vises i applikationen",
  "settings.update": "Opdater",
  "settings.updateYourProfile": "Opdater din profil",
  "settings.updateYourProfileDescription": "Navn og visningsindstillinger",
  "settings.weatherServices": "Vejrtjenester",
  "settings.weatherServicesConnected": "{count, plural, =0 {Ingen tjenester tilsluttet} one {# tjeneste tilsluttet} other {# tjenester tilsluttet}}",
  "settings.weatherServicesDescription": "Forbind Netatmo, Davis, Weatherflow og mere",
  "settings.windDirectionConvention": "Vindretningspil",
  "settings.windDirectionConventionDescription": "Vælg hvordan vindretningspile vises",
  "settings.windDirectionMeteorological": "Oprindelsesretning",
  "settings.windDirectionMeteorologicalDescription": "Pilen viser hvor vinden kommer fra (meteorologisk konvention)",
  "settings.windDirectionOceanographic": "Strømningsretning",
  "settings.windDirectionOceanographicDescription": "Pilen viser hvor vinden blæser hen (oceanografisk konvention)",
  "units.absolutePressure": "Absolut pres",
  "units.airDensity": "Luftdensitet",
  "units.airGap": "Luftspalte",
  "units.apparentTemperature": "Tilsyneladende temperatur",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "Gns.",
  "units.avg_wind": "Gennemsnitlig vindstyrke",
  "units.beaufort": "Beaufort",
  "units.blackGlobeTemperature": "Sortglobe temp.",
  "units.boilerOn": "Kedel tændt",
  "units.co2": "CO2",
  "units.conductivity": "Ledningsevne",
  "units.coolingDegreeDays": "Kølende graddage",
  "units.dailyHeatingDuration": "Daglig opvarmningsvarighed",
  "units.dailyPrecipitation": "Daglig nedbør",
  "units.dailyRain": "Daglig regn",
  "units.degreeDay": "Graddag",
  "units.degreeDayShort": "DD",
  "units.depth": "Dybde",
  "units.depthSensors": "Dybdesensorer",
  "units.dewPoint": "Dugpunkt",
  "units.distance": "Afstand",
  "units.downTrend": "Ned",
  "units.E": "Ø",
  "units.E_long": "Øst",
  "units.ENE": "ØNØ",
  "units.ENE_long": "Øst-Nordøst",
  "units.ESE": "ØSØ",
  "units.ESE_long": "Øst-Sydøst",
  "units.ET": "Evapotranspiration",
  "units.ETshort": "ET",
  "units.feelLike": "Føles som",
  "units.feelsLike": "Føles som",
  "units.footMile": "Fod, mil",
  "units.frostPoint": "frostpunkt",
  "units.gust": "Vindstød",
  "units.heatIndex": "Varmeindeks",
  "units.heatingDegreeDays": "Varmegradsdage",
  "units.heatingPower": "Varmeeffekt",
  "units.humidex": "Luftfugtighedsindeks",
  "units.humidity": "Luftfugtighed",
  "units.inch": "Tommer",
  "units.inchOfMercury": "Tommer kviksølv",
  "units.kilometerPerHour": "Kilometer i timen",
  "units.knot": "Knob",
  "units.last12Hours": "Sidste 12 timer",
  "units.last24Hours": "Sidste 24 timer",
  "units.last3Hours": "Sidste 3 timer",
  "units.last6Hours": "Sidste 6 timer",
  "units.lastHour": "Seneste time",
  "units.lastLightningImpact": "Sidste påvirkning",
  "units.lastMeasure": "Sidste måling",
  "units.leafSensors": "Bladfølere",
  "units.leafWetness": "Blad fugt",
  "units.lightningDistance": "Afstand",
  "units.lightningStrikeCount": "Antal lynnedslag",
  "units.lightningStrikeDistance": "Lynnedslagsafstand",
  "units.max": "Maks.",
  "units.max_gust": "Maks. vindstød",
  "units.max_wind": "Maks. vindstyrke",
  "units.meterKilometer": "Meter, kilometer",
  "units.meterPerSecond": "Meter pr. sekund",
  "units.milePerHour": "Mil pr. time",
  "units.millibar": "Millibar",
  "units.millimeter": "Millimeter",
  "units.millimeterOfMercury": "Millimeter kviksølv",
  "units.min": "Min.",
  "units.N": "N",
  "units.N_long": "Nord",
  "units.NE": "NØ",
  "units.NE_long": "Nordøst",
  "units.NNE": "NNØ",
  "units.NNE_long": "Nord-Nordøst",
  "units.NNW": "NNV",
  "units.NNW_long": "Nord-Nordvest",
  "units.noise": "Støj",
  "units.normalizedHeatingCoefficient": "Normaliseret varmekoefficient",
  "units.NW": "NV",
  "units.NW_long": "Nordvest",
  "units.O3": "Ozon",
  "units.PM_1": "PM1",
  "units.PM_10": "PM10",
  "units.PM_2P5": "PM2.5",
  "units.precipitation": "Nedbør",
  "units.pressure": "Lufttryk",
  "units.rain": "Regn",
  "units.rainRate": "Regnintensitet",
  "units.referenceTemperature": "Referencetemperatur",
  "units.relativePressure": "Relativt pres",
  "units.S": "S",
  "units.S_long": "Syd",
  "units.SE": "SØ",
  "units.SE_long": "Sydøst",
  "units.setPoint": "Sætpunkt",
  "units.snow": "Sne",
  "units.snowfall": "Snefald",
  "units.soilMoisture": "Fugtighed",
  "units.soilSensors": "Jordfølere",
  "units.solarEnergy": "Solenergi",
  "units.solarRadiation": "Solstråling",
  "units.speed": "Hastighed",
  "units.SSE": "SSØ",
  "units.SSE_long": "Syd-Sydøst",
  "units.SSW": "SSV",
  "units.SSW_long": "Syd-Sydvest",
  "units.stableTrend": "Stabil",
  "units.sum": "Sum",
  "units.SW": "SV",
  "units.SW_long": "Sydvest",
  "units.temperature": "Temperatur",
  "units.temperatureAndHumiditySensors": "Temperatur & fugtughedsmålere",
  "units.temperatureSensors": "Temperatur & fugtughedsmålere",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "I dag",
  "units.upTrend": "op",
  "units.uv": "UV",
  "units.visibility": "Sigtbarhed",
  "units.W": "V",
  "units.W_long": "Vest",
  "units.wetBulbGlobeTemperature": "Våd kugletemperatur",
  "units.wetBulbTemperature": "Våd pære temp.",
  "units.wind": "Vind",
  "units.windChill": "Vind Chill",
  "units.windDirection": "Vindretning",
  "units.windRun": "vindens gang",
  "units.windRunDescription": "Vindvandring er den samlede afstand, vinden tilbagelagt over en periode",
  "units.WNW": "VNV",
  "units.WNW_long": "Vest-Nordvest",
  "units.WSW": "VSV",
  "units.WSW_long": "Vest-Sydvest"
}
